var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/NxSpot.tsx
import React374 from "react";
import { capitalize, useTheme } from "@material-ui/core";

// src/components/index.ts
var components_exports = {};
__export(components_exports, {
  DarkArenaPrimaryLarge: () => DarkArenaPrimaryLarge_default,
  DarkArenaPrimarySmall: () => DarkArenaPrimarySmall_default,
  DarkArenaSecondaryLarge: () => DarkArenaSecondaryLarge_default,
  DarkArenaSecondarySmall: () => DarkArenaSecondarySmall_default,
  DarkAwardPrimaryLarge: () => DarkAwardPrimaryLarge_default,
  DarkAwardPrimarySmall: () => DarkAwardPrimarySmall_default,
  DarkAwardSecondaryLarge: () => DarkAwardSecondaryLarge_default,
  DarkAwardSecondarySmall: () => DarkAwardSecondarySmall_default,
  DarkBillingPrimaryLarge: () => DarkBillingPrimaryLarge_default,
  DarkBillingPrimarySmall: () => DarkBillingPrimarySmall_default,
  DarkBillingSecondaryLarge: () => DarkBillingSecondaryLarge_default,
  DarkBillingSecondarySmall: () => DarkBillingSecondarySmall_default,
  DarkCaptainPrimaryLarge: () => DarkCaptainPrimaryLarge_default,
  DarkCaptainPrimarySmall: () => DarkCaptainPrimarySmall_default,
  DarkCaptainSecondaryLarge: () => DarkCaptainSecondaryLarge_default,
  DarkCaptainSecondarySmall: () => DarkCaptainSecondarySmall_default,
  DarkCharacterSelectPrimaryLarge: () => DarkCharacterSelectPrimaryLarge_default,
  DarkCharacterSelectPrimarySmall: () => DarkCharacterSelectPrimarySmall_default,
  DarkCharacterSelectSecondaryLarge: () => DarkCharacterSelectSecondaryLarge_default,
  DarkCharacterSelectSecondarySmall: () => DarkCharacterSelectSecondarySmall_default,
  DarkChatPrimaryLarge: () => DarkChatPrimaryLarge_default,
  DarkChatPrimarySmall: () => DarkChatPrimarySmall_default,
  DarkChatSecondaryLarge: () => DarkChatSecondaryLarge_default,
  DarkChatSecondarySmall: () => DarkChatSecondarySmall_default,
  DarkCheckboxPrimaryLarge: () => DarkCheckboxPrimaryLarge_default,
  DarkCheckboxPrimarySmall: () => DarkCheckboxPrimarySmall_default,
  DarkCheckboxSecondaryLarge: () => DarkCheckboxSecondaryLarge_default,
  DarkCheckboxSecondarySmall: () => DarkCheckboxSecondarySmall_default,
  DarkCoachPrimaryLarge: () => DarkCoachPrimaryLarge_default,
  DarkCoachPrimarySmall: () => DarkCoachPrimarySmall_default,
  DarkCoachSecondaryLarge: () => DarkCoachSecondaryLarge_default,
  DarkCoachSecondarySmall: () => DarkCoachSecondarySmall_default,
  DarkConnectedAccountsPrimaryLarge: () => DarkConnectedAccountsPrimaryLarge_default,
  DarkConnectedAccountsPrimarySmall: () => DarkConnectedAccountsPrimarySmall_default,
  DarkConnectedAccountsSecondaryLarge: () => DarkConnectedAccountsSecondaryLarge_default,
  DarkConnectedAccountsSecondarySmall: () => DarkConnectedAccountsSecondarySmall_default,
  DarkConnectionPrimaryLarge: () => DarkConnectionPrimaryLarge_default,
  DarkConnectionPrimarySmall: () => DarkConnectionPrimarySmall_default,
  DarkConnectionSecondaryLarge: () => DarkConnectionSecondaryLarge_default,
  DarkConnectionSecondarySmall: () => DarkConnectionSecondarySmall_default,
  DarkConstructionPrimaryLarge: () => DarkConstructionPrimaryLarge_default,
  DarkConstructionPrimaryMedium: () => DarkConstructionPrimaryMedium_default,
  DarkConstructionPrimarySmall: () => DarkConstructionPrimarySmall_default,
  DarkConstructionSecondaryLarge: () => DarkConstructionSecondaryLarge_default,
  DarkConstructionSecondaryMedium: () => DarkConstructionSecondaryMedium_default,
  DarkConstructionSecondarySmall: () => DarkConstructionSecondarySmall_default,
  DarkCoursePrimaryLarge: () => DarkCoursePrimaryLarge_default,
  DarkCoursePrimarySmall: () => DarkCoursePrimarySmall_default,
  DarkCourseSecondaryLarge: () => DarkCourseSecondaryLarge_default,
  DarkCourseSecondarySmall: () => DarkCourseSecondarySmall_default,
  DarkCreateTeamPrimaryLarge: () => DarkCreateTeamPrimaryLarge_default,
  DarkCreateTeamPrimarySmall: () => DarkCreateTeamPrimarySmall_default,
  DarkCreateTeamSecondaryLarge: () => DarkCreateTeamSecondaryLarge_default,
  DarkCreateTeamSecondarySmall: () => DarkCreateTeamSecondarySmall_default,
  DarkCrownPrimaryLarge: () => DarkCrownPrimaryLarge_default,
  DarkCrownPrimarySmall: () => DarkCrownPrimarySmall_default,
  DarkCrownSecondaryLarge: () => DarkCrownSecondaryLarge_default,
  DarkCrownSecondarySmall: () => DarkCrownSecondarySmall_default,
  DarkEmailVerificationPrimaryLarge: () => DarkEmailVerificationPrimaryLarge_default,
  DarkEmailVerificationPrimarySmall: () => DarkEmailVerificationPrimarySmall_default,
  DarkEmailVerificationSecondaryLarge: () => DarkEmailVerificationSecondaryLarge_default,
  DarkEmailVerificationSecondarySmall: () => DarkEmailVerificationSecondarySmall_default,
  DarkEnrollmentLoaderPrimaryLarge: () => DarkEnrollmentLoaderPrimaryLarge_default,
  DarkEnrollmentPrimaryLarge: () => DarkEnrollmentPrimaryLarge_default,
  DarkEnrollmentPrimarySmall: () => DarkEnrollmentPrimarySmall_default,
  DarkEnrollmentSecondaryLarge: () => DarkEnrollmentSecondaryLarge_default,
  DarkEnrollmentSecondarySmall: () => DarkEnrollmentSecondarySmall_default,
  DarkErrorStateLarge: () => DarkErrorStateLarge_default,
  DarkFlagsDarkPrimaryLarge: () => DarkFlagsDarkPrimaryLarge_default,
  DarkFlagsDarkPrimarySmall: () => DarkFlagsDarkPrimarySmall_default,
  DarkFlagsDarkSecondaryLarge: () => DarkFlagsDarkSecondaryLarge_default,
  DarkFoamFingerPrimaryLarge: () => DarkFoamFingerPrimaryLarge_default,
  DarkFoamFingerPrimarySmall: () => DarkFoamFingerPrimarySmall_default,
  DarkFoamFingerSecondaryLarge: () => DarkFoamFingerSecondaryLarge_default,
  DarkFoamFingerSecondarySmall: () => DarkFoamFingerSecondarySmall_default,
  DarkGraduationHatPrimaryLarge: () => DarkGraduationHatPrimaryLarge_default,
  DarkGraduationHatPrimarySmall: () => DarkGraduationHatPrimarySmall_default,
  DarkGraduationHatSecondaryLarge: () => DarkGraduationHatSecondaryLarge_default,
  DarkGraduationHatSecondarySmall: () => DarkGraduationHatSecondarySmall_default,
  DarkHighAlertPrimaryLarge: () => DarkHighAlertPrimaryLarge_default,
  DarkHighAlertPrimarySmall: () => DarkHighAlertPrimarySmall_default,
  DarkHighAlertSecondaryLarge: () => DarkHighAlertSecondaryLarge_default,
  DarkHighAlertSecondarySmall: () => DarkHighAlertSecondarySmall_default,
  DarkInvitePlayersPrimaryLarge: () => DarkInvitePlayersPrimaryLarge_default,
  DarkInvitePlayersPrimarySmall: () => DarkInvitePlayersPrimarySmall_default,
  DarkInvitePlayersSecondaryLarge: () => DarkInvitePlayersSecondaryLarge_default,
  DarkInvitePlayersSecondarySmall: () => DarkInvitePlayersSecondarySmall_default,
  DarkKeyboardPrimaryLarge: () => DarkKeyboardPrimaryLarge_default,
  DarkKeyboardPrimarySmall: () => DarkKeyboardPrimarySmall_default,
  DarkKeyboardSecondaryLarge: () => DarkKeyboardSecondaryLarge_default,
  DarkKeyboardSecondarySmall: () => DarkKeyboardSecondarySmall_default,
  DarkLeaguePrimaryLarge: () => DarkLeaguePrimaryLarge_default,
  DarkLeaguePrimarySmall: () => DarkLeaguePrimarySmall_default,
  DarkLeagueSecondaryLarge: () => DarkLeagueSecondaryLarge_default,
  DarkLeagueSecondarySmall: () => DarkLeagueSecondarySmall_default,
  DarkMegaphonePrimaryLarge: () => DarkMegaphonePrimaryLarge_default,
  DarkMegaphonePrimarySmall: () => DarkMegaphonePrimarySmall_default,
  DarkMegaphoneSecondaryLarge: () => DarkMegaphoneSecondaryLarge_default,
  DarkMegaphoneSecondarySmall: () => DarkMegaphoneSecondarySmall_default,
  DarkMoneyPrimaryLarge: () => DarkMoneyPrimaryLarge_default,
  DarkMoneyPrimaryMedium: () => DarkMoneyPrimaryMedium_default,
  DarkMoneyPrimarySmall: () => DarkMoneyPrimarySmall_default,
  DarkMoneySecondaryLarge: () => DarkMoneySecondaryLarge_default,
  DarkMoneySecondaryMedium: () => DarkMoneySecondaryMedium_default,
  DarkMoneySecondarySmall: () => DarkMoneySecondarySmall_default,
  DarkMousePrimaryLarge: () => DarkMousePrimaryLarge_default,
  DarkMousePrimarySmall: () => DarkMousePrimarySmall_default,
  DarkMouseSecondaryLarge: () => DarkMouseSecondaryLarge_default,
  DarkMouseSecondarySmall: () => DarkMouseSecondarySmall_default,
  DarkNotVerifiedPrimaryLarge: () => DarkNotVerifiedPrimaryLarge_default,
  DarkNotVerifiedPrimarySmall: () => DarkNotVerifiedPrimarySmall_default,
  DarkNotVerifiedSecondaryLarge: () => DarkNotVerifiedSecondaryLarge_default,
  DarkNotVerifiedSecondarySmall: () => DarkNotVerifiedSecondarySmall_default,
  DarkNotificationPrimaryLarge: () => DarkNotificationPrimaryLarge_default,
  DarkNotificationPrimarySmall: () => DarkNotificationPrimarySmall_default,
  DarkNotificationSecondaryLarge: () => DarkNotificationSecondaryLarge_default,
  DarkNotificationSecondarySmall: () => DarkNotificationSecondarySmall_default,
  DarkPassPrimaryLarge: () => DarkPassPrimaryLarge_default,
  DarkPassPrimarySmall: () => DarkPassPrimarySmall_default,
  DarkPassSecondaryLarge: () => DarkPassSecondaryLarge_default,
  DarkPassSecondarySmall: () => DarkPassSecondarySmall_default,
  DarkPendingPrimaryLarge: () => DarkPendingPrimaryLarge_default,
  DarkPendingPrimarySmall: () => DarkPendingPrimarySmall_default,
  DarkPendingSecondaryLarge: () => DarkPendingSecondaryLarge_default,
  DarkPendingSecondarySmall: () => DarkPendingSecondarySmall_default,
  DarkProductTourSecondaryLarge: () => DarkProductTourSecondaryLarge_default,
  DarkProductTourSecondaryMedium: () => DarkProductTourSecondaryMedium_default,
  DarkProductTourSecondarySmall: () => DarkProductTourSecondarySmall_default,
  DarkResourcesPrimaryLarge: () => DarkResourcesPrimaryLarge_default,
  DarkResourcesPrimaryMedium: () => DarkResourcesPrimaryMedium_default,
  DarkResourcesPrimarySmall: () => DarkResourcesPrimarySmall_default,
  DarkResourcesSecondaryLarge: () => DarkResourcesSecondaryLarge_default,
  DarkResourcesSecondaryMedium: () => DarkResourcesSecondaryMedium_default,
  DarkResourcesSecondarySmall: () => DarkResourcesSecondarySmall_default,
  DarkRewardPrimaryLarge: () => DarkRewardPrimaryLarge_default,
  DarkRewardPrimarySmall: () => DarkRewardPrimarySmall_default,
  DarkRewardSecondaryLarge: () => DarkRewardSecondaryLarge_default,
  DarkRewardSecondarySmall: () => DarkRewardSecondarySmall_default,
  DarkSchedulePrimaryLarge: () => DarkSchedulePrimaryLarge_default,
  DarkSchedulePrimarySmall: () => DarkSchedulePrimarySmall_default,
  DarkScheduleSecondaryLarge: () => DarkScheduleSecondaryLarge_default,
  DarkScheduleSecondarySmall: () => DarkScheduleSecondarySmall_default,
  DarkSchoolPrimaryLarge: () => DarkSchoolPrimaryLarge_default,
  DarkSchoolPrimarySmall: () => DarkSchoolPrimarySmall_default,
  DarkSchoolSecondaryLarge: () => DarkSchoolSecondaryLarge_default,
  DarkSchoolSecondarySmall: () => DarkSchoolSecondarySmall_default,
  DarkSportsmanshipPrimaryLarge: () => DarkSportsmanshipPrimaryLarge_default,
  DarkSportsmanshipPrimarySmall: () => DarkSportsmanshipPrimarySmall_default,
  DarkSportsmanshipSecondaryLarge: () => DarkSportsmanshipSecondaryLarge_default,
  DarkSportsmanshipSecondarySmall: () => DarkSportsmanshipSecondarySmall_default,
  DarkStadiumPrimaryLarge: () => DarkStadiumPrimaryLarge_default,
  DarkStadiumPrimarySmall: () => DarkStadiumPrimarySmall_default,
  DarkStadiumSecondaryLarge: () => DarkStadiumSecondaryLarge_default,
  DarkStadiumSecondarySmall: () => DarkStadiumSecondarySmall_default,
  DarkStandingPrimaryLarge: () => DarkStandingPrimaryLarge_default,
  DarkStandingPrimarySmall: () => DarkStandingPrimarySmall_default,
  DarkStandingSecondaryLarge: () => DarkStandingSecondaryLarge_default,
  DarkStandingSecondarySmall: () => DarkStandingSecondarySmall_default,
  DarkStatsPrimaryLarge: () => DarkStatsPrimaryLarge_default,
  DarkStatsPrimarySmall: () => DarkStatsPrimarySmall_default,
  DarkStatsSecondaryLarge: () => DarkStatsSecondaryLarge_default,
  DarkStatsSecondarySmall: () => DarkStatsSecondarySmall_default,
  DarkStrategyPrimaryLarge: () => DarkStrategyPrimaryLarge_default,
  DarkStrategyPrimarySmall: () => DarkStrategyPrimarySmall_default,
  DarkStrategySecondaryLarge: () => DarkStrategySecondaryLarge_default,
  DarkStrategySecondarySmall: () => DarkStrategySecondarySmall_default,
  DarkTeamPlayerPrimaryLarge: () => DarkTeamPlayerPrimaryLarge_default,
  DarkTeamPlayerPrimarySmall: () => DarkTeamPlayerPrimarySmall_default,
  DarkTeamPlayerSecondaryLarge: () => DarkTeamPlayerSecondaryLarge_default,
  DarkTeamPlayerSecondarySmall: () => DarkTeamPlayerSecondarySmall_default,
  DarkTrophyPrimaryLarge: () => DarkTrophyPrimaryLarge_default,
  DarkTrophyPrimarySmall: () => DarkTrophyPrimarySmall_default,
  DarkTrophySecondaryLarge: () => DarkTrophySecondaryLarge_default,
  DarkTrophySecondarySmall: () => DarkTrophySecondarySmall_default,
  DarkUploadDocPrimaryLarge: () => DarkUploadDocPrimaryLarge_default,
  DarkUploadDocPrimarySmall: () => DarkUploadDocPrimarySmall_default,
  DarkUploadDocSecondaryLarge: () => DarkUploadDocSecondaryLarge_default,
  DarkUploadDocSecondarySmall: () => DarkUploadDocSecondarySmall_default,
  DarkVerificationPrimaryLarge: () => DarkVerificationPrimaryLarge_default,
  DarkVerificationPrimarySmall: () => DarkVerificationPrimarySmall_default,
  DarkVerificationSecondaryLarge: () => DarkVerificationSecondaryLarge_default,
  DarkVerificationSecondarySmall: () => DarkVerificationSecondarySmall_default,
  DarkVideoPrimaryLarge: () => DarkVideoPrimaryLarge_default,
  DarkVideoPrimarySmall: () => DarkVideoPrimarySmall_default,
  DarkVideoSecondaryLarge: () => DarkVideoSecondaryLarge_default,
  DarkVideoSecondarySmall: () => DarkVideoSecondarySmall_default,
  LightArenaPrimaryLarge: () => LightArenaPrimaryLarge_default,
  LightArenaPrimarySmall: () => LightArenaPrimarySmall_default,
  LightArenaSecondaryLarge: () => LightArenaSecondaryLarge_default,
  LightArenaSecondarySmall: () => LightArenaSecondarySmall_default,
  LightAwardPrimaryLarge: () => LightAwardPrimaryLarge_default,
  LightAwardPrimarySmall: () => LightAwardPrimarySmall_default,
  LightAwardSecondaryLarge: () => LightAwardSecondaryLarge_default,
  LightAwardSecondarySmall: () => LightAwardSecondarySmall_default,
  LightBillingPrimaryLarge: () => LightBillingPrimaryLarge_default,
  LightBillingPrimarySmall: () => LightBillingPrimarySmall_default,
  LightBillingSecondaryLarge: () => LightBillingSecondaryLarge_default,
  LightBillingSecondarySmall: () => LightBillingSecondarySmall_default,
  LightCaptainPrimaryLarge: () => LightCaptainPrimaryLarge_default,
  LightCaptainPrimarySmall: () => LightCaptainPrimarySmall_default,
  LightCaptainSecondaryLarge: () => LightCaptainSecondaryLarge_default,
  LightCaptainSecondarySmall: () => LightCaptainSecondarySmall_default,
  LightCharacterSelectPrimaryLarge: () => LightCharacterSelectPrimaryLarge_default,
  LightCharacterSelectPrimarySmall: () => LightCharacterSelectPrimarySmall_default,
  LightCharacterSelectSecondaryLarge: () => LightCharacterSelectSecondaryLarge_default,
  LightCharacterSelectSecondarySmall: () => LightCharacterSelectSecondarySmall_default,
  LightChatPrimaryLarge: () => LightChatPrimaryLarge_default,
  LightChatPrimarySmall: () => LightChatPrimarySmall_default,
  LightChatSecondaryLarge: () => LightChatSecondaryLarge_default,
  LightChatSecondarySmall: () => LightChatSecondarySmall_default,
  LightCheckboxPrimaryLarge: () => LightCheckboxPrimaryLarge_default,
  LightCheckboxPrimarySmall: () => LightCheckboxPrimarySmall_default,
  LightCheckboxSecondaryLarge: () => LightCheckboxSecondaryLarge_default,
  LightCheckboxSecondarySmall: () => LightCheckboxSecondarySmall_default,
  LightCoachPrimaryLarge: () => LightCoachPrimaryLarge_default,
  LightCoachPrimarySmall: () => LightCoachPrimarySmall_default,
  LightCoachSecondaryLarge: () => LightCoachSecondaryLarge_default,
  LightCoachSecondarySmall: () => LightCoachSecondarySmall_default,
  LightConnectedAccountsPrimaryLarge: () => LightConnectedAccountsPrimaryLarge_default,
  LightConnectedAccountsPrimarySmall: () => LightConnectedAccountsPrimarySmall_default,
  LightConnectedAccountsSecondaryLarge: () => LightConnectedAccountsSecondaryLarge_default,
  LightConnectedAccountsSecondarySmall: () => LightConnectedAccountsSecondarySmall_default,
  LightConnectionPrimaryLarge: () => LightConnectionPrimaryLarge_default,
  LightConnectionPrimarySmall: () => LightConnectionPrimarySmall_default,
  LightConnectionSecondaryLarge: () => LightConnectionSecondaryLarge_default,
  LightConnectionSecondarySmall: () => LightConnectionSecondarySmall_default,
  LightConstructionPrimaryLarge: () => LightConstructionPrimaryLarge_default,
  LightConstructionPrimaryMedium: () => LightConstructionPrimaryMedium_default,
  LightConstructionPrimarySmall: () => LightConstructionPrimarySmall_default,
  LightConstructionSecondaryLarge: () => LightConstructionSecondaryLarge_default,
  LightConstructionSecondaryMedium: () => LightConstructionSecondaryMedium_default,
  LightConstructionSecondarySmall: () => LightConstructionSecondarySmall_default,
  LightCoursePrimaryLarge: () => LightCoursePrimaryLarge_default,
  LightCoursePrimarySmall: () => LightCoursePrimarySmall_default,
  LightCourseSecondaryLarge: () => LightCourseSecondaryLarge_default,
  LightCourseSecondarySmall: () => LightCourseSecondarySmall_default,
  LightCreateTeamPrimaryLarge: () => LightCreateTeamPrimaryLarge_default,
  LightCreateTeamPrimarySmall: () => LightCreateTeamPrimarySmall_default,
  LightCreateTeamSecondaryLarge: () => LightCreateTeamSecondaryLarge_default,
  LightCreateTeamSecondarySmall: () => LightCreateTeamSecondarySmall_default,
  LightCrownPrimaryLarge: () => LightCrownPrimaryLarge_default,
  LightCrownPrimarySmall: () => LightCrownPrimarySmall_default,
  LightCrownSecondaryLarge: () => LightCrownSecondaryLarge_default,
  LightCrownSecondarySmall: () => LightCrownSecondarySmall_default,
  LightEmailVerificationPrimaryLarge: () => LightEmailVerificationPrimaryLarge_default,
  LightEmailVerificationPrimarySmall: () => LightEmailVerificationPrimarySmall_default,
  LightEmailVerificationSecondaryLarge: () => LightEmailVerificationSecondaryLarge_default,
  LightEmailVerificationSecondarySmall: () => LightEmailVerificationSecondarySmall_default,
  LightEnrollmentLoaderPrimaryLarge: () => LightEnrollmentLoaderPrimaryLarge_default,
  LightEnrollmentPrimaryLarge: () => LightEnrollmentPrimaryLarge_default,
  LightEnrollmentPrimarySmall: () => LightEnrollmentPrimarySmall_default,
  LightEnrollmentSecondaryLarge: () => LightEnrollmentSecondaryLarge_default,
  LightEnrollmentSecondarySmall: () => LightEnrollmentSecondarySmall_default,
  LightErrorStateLarge: () => LightErrorStateLarge_default,
  LightFlagsLightPrimaryLarge: () => LightFlagsLightPrimaryLarge_default,
  LightFlagsLightPrimarySmall: () => LightFlagsLightPrimarySmall_default,
  LightFlagsLightSecondaryLarge: () => LightFlagsLightSecondaryLarge_default,
  LightFlagsLightSecondarySmall: () => LightFlagsLightSecondarySmall_default,
  LightFoamFingerPrimaryLarge: () => LightFoamFingerPrimaryLarge_default,
  LightFoamFingerPrimarySmall: () => LightFoamFingerPrimarySmall_default,
  LightFoamFingerSecondaryLarge: () => LightFoamFingerSecondaryLarge_default,
  LightFoamFingerSecondarySmall: () => LightFoamFingerSecondarySmall_default,
  LightGraduationHatPrimaryLarge: () => LightGraduationHatPrimaryLarge_default,
  LightGraduationHatPrimarySmall: () => LightGraduationHatPrimarySmall_default,
  LightGraduationHatSecondaryLarge: () => LightGraduationHatSecondaryLarge_default,
  LightGraduationHatSecondarySmall: () => LightGraduationHatSecondarySmall_default,
  LightHighAlertPrimaryLarge: () => LightHighAlertPrimaryLarge_default,
  LightHighAlertPrimarySmall: () => LightHighAlertPrimarySmall_default,
  LightHighAlertSecondaryLarge: () => LightHighAlertSecondaryLarge_default,
  LightHighAlertSecondarySmall: () => LightHighAlertSecondarySmall_default,
  LightInvitePlayersPrimaryLarge: () => LightInvitePlayersPrimaryLarge_default,
  LightInvitePlayersPrimarySmall: () => LightInvitePlayersPrimarySmall_default,
  LightInvitePlayersSecondaryLarge: () => LightInvitePlayersSecondaryLarge_default,
  LightInvitePlayersSecondarySmall: () => LightInvitePlayersSecondarySmall_default,
  LightKeyboardPrimaryLarge: () => LightKeyboardPrimaryLarge_default,
  LightKeyboardPrimarySmall: () => LightKeyboardPrimarySmall_default,
  LightKeyboardSecondaryLarge: () => LightKeyboardSecondaryLarge_default,
  LightKeyboardSecondarySmall: () => LightKeyboardSecondarySmall_default,
  LightLeaguePrimaryLarge: () => LightLeaguePrimaryLarge_default,
  LightLeaguePrimarySmall: () => LightLeaguePrimarySmall_default,
  LightLeagueSecondaryLarge: () => LightLeagueSecondaryLarge_default,
  LightLeagueSecondarySmall: () => LightLeagueSecondarySmall_default,
  LightMegaphonePrimaryLarge: () => LightMegaphonePrimaryLarge_default,
  LightMegaphonePrimarySmall: () => LightMegaphonePrimarySmall_default,
  LightMegaphoneSecondaryLarge: () => LightMegaphoneSecondaryLarge_default,
  LightMegaphoneSecondarySmall: () => LightMegaphoneSecondarySmall_default,
  LightMoneyPrimaryLarge: () => LightMoneyPrimaryLarge_default,
  LightMoneyPrimarySmall: () => LightMoneyPrimarySmall_default,
  LightMoneySecondaryLarge: () => LightMoneySecondaryLarge_default,
  LightMoneySecondarySmall: () => LightMoneySecondarySmall_default,
  LightMousePrimaryLarge: () => LightMousePrimaryLarge_default,
  LightMousePrimarySmall: () => LightMousePrimarySmall_default,
  LightMouseSecondaryLarge: () => LightMouseSecondaryLarge_default,
  LightMouseSecondarySmall: () => LightMouseSecondarySmall_default,
  LightNotVerifiedPrimaryLarge: () => LightNotVerifiedPrimaryLarge_default,
  LightNotVerifiedPrimarySmall: () => LightNotVerifiedPrimarySmall_default,
  LightNotVerifiedSecondaryLarge: () => LightNotVerifiedSecondaryLarge_default,
  LightNotVerifiedSecondarySmall: () => LightNotVerifiedSecondarySmall_default,
  LightNotificationPrimaryLarge: () => LightNotificationPrimaryLarge_default,
  LightNotificationPrimarySmall: () => LightNotificationPrimarySmall_default,
  LightNotificationSecondarySmall: () => LightNotificationSecondarySmall_default,
  LightPassPrimaryLarge: () => LightPassPrimaryLarge_default,
  LightPassPrimarySmall: () => LightPassPrimarySmall_default,
  LightPassSecondaryLarge: () => LightPassSecondaryLarge_default,
  LightPassSecondarySmall: () => LightPassSecondarySmall_default,
  LightPendingPrimaryLarge: () => LightPendingPrimaryLarge_default,
  LightPendingPrimarySmall: () => LightPendingPrimarySmall_default,
  LightPendingSecondaryLarge: () => LightPendingSecondaryLarge_default,
  LightPendingSecondarySmall: () => LightPendingSecondarySmall_default,
  LightProductTourPrimaryLarge: () => LightProductTourPrimaryLarge_default,
  LightProductTourPrimaryMedium: () => LightProductTourPrimaryMedium_default,
  LightProductTourPrimarySmall: () => LightProductTourPrimarySmall_default,
  LightProductTourSecondaryLarge: () => LightProductTourSecondaryLarge_default,
  LightProductTourSecondaryMedium: () => LightProductTourSecondaryMedium_default,
  LightProductTourSecondarySmall: () => LightProductTourSecondarySmall_default,
  LightResourcesPrimaryLarge: () => LightResourcesPrimaryLarge_default,
  LightResourcesPrimaryMedium: () => LightResourcesPrimaryMedium_default,
  LightResourcesPrimarySmall: () => LightResourcesPrimarySmall_default,
  LightResourcesSecondaryLarge: () => LightResourcesSecondaryLarge_default,
  LightResourcesSecondaryMedium: () => LightResourcesSecondaryMedium_default,
  LightResourcesSecondarySmall: () => LightResourcesSecondarySmall_default,
  LightRewardPrimaryLarge: () => LightRewardPrimaryLarge_default,
  LightRewardPrimarySmall: () => LightRewardPrimarySmall_default,
  LightRewardSecondaryLarge: () => LightRewardSecondaryLarge_default,
  LightRewardSecondarySmall: () => LightRewardSecondarySmall_default,
  LightSchedulePrimaryLarge: () => LightSchedulePrimaryLarge_default,
  LightSchedulePrimarySmall: () => LightSchedulePrimarySmall_default,
  LightScheduleSecondaryLarge: () => LightScheduleSecondaryLarge_default,
  LightScheduleSecondarySmall: () => LightScheduleSecondarySmall_default,
  LightSchoolPrimaryLarge: () => LightSchoolPrimaryLarge_default,
  LightSchoolPrimarySmall: () => LightSchoolPrimarySmall_default,
  LightSchoolSecondaryLarge: () => LightSchoolSecondaryLarge_default,
  LightSchoolSecondarySmall: () => LightSchoolSecondarySmall_default,
  LightSportsmanshipPrimaryLarge: () => LightSportsmanshipPrimaryLarge_default,
  LightSportsmanshipPrimarySmall: () => LightSportsmanshipPrimarySmall_default,
  LightSportsmanshipSecondaryLarge: () => LightSportsmanshipSecondaryLarge_default,
  LightSportsmanshipSecondarySmall: () => LightSportsmanshipSecondarySmall_default,
  LightStadiumPrimaryLarge: () => LightStadiumPrimaryLarge_default,
  LightStadiumPrimarySmall: () => LightStadiumPrimarySmall_default,
  LightStadiumSecondaryLarge: () => LightStadiumSecondaryLarge_default,
  LightStadiumSecondarySmall: () => LightStadiumSecondarySmall_default,
  LightStandingPrimaryLarge: () => LightStandingPrimaryLarge_default,
  LightStandingPrimarySmall: () => LightStandingPrimarySmall_default,
  LightStandingSecondaryLarge: () => LightStandingSecondaryLarge_default,
  LightStandingSecondarySmall: () => LightStandingSecondarySmall_default,
  LightStatsPrimaryLarge: () => LightStatsPrimaryLarge_default,
  LightStatsPrimarySmall: () => LightStatsPrimarySmall_default,
  LightStatsSecondaryLarge: () => LightStatsSecondaryLarge_default,
  LightStatsSecondarySmall: () => LightStatsSecondarySmall_default,
  LightStrategyPrimaryLarge: () => LightStrategyPrimaryLarge_default,
  LightStrategyPrimarySmall: () => LightStrategyPrimarySmall_default,
  LightStrategySecondaryLarge: () => LightStrategySecondaryLarge_default,
  LightStrategySecondarySmall: () => LightStrategySecondarySmall_default,
  LightTeamPlayerPrimaryLarge: () => LightTeamPlayerPrimaryLarge_default,
  LightTeamPlayerPrimarySmall: () => LightTeamPlayerPrimarySmall_default,
  LightTeamPlayerSecondaryLarge: () => LightTeamPlayerSecondaryLarge_default,
  LightTeamPlayerSecondarySmall: () => LightTeamPlayerSecondarySmall_default,
  LightTrophyPrimaryLarge: () => LightTrophyPrimaryLarge_default,
  LightTrophyPrimarySmall: () => LightTrophyPrimarySmall_default,
  LightTrophySecondaryLarge: () => LightTrophySecondaryLarge_default,
  LightTrophySecondarySmall: () => LightTrophySecondarySmall_default,
  LightUploadDocPrimaryLarge: () => LightUploadDocPrimaryLarge_default,
  LightUploadDocPrimarySmall: () => LightUploadDocPrimarySmall_default,
  LightUploadDocSecondaryLarge: () => LightUploadDocSecondaryLarge_default,
  LightUploadDocSecondarySmall: () => LightUploadDocSecondarySmall_default,
  LightVerificationPrimaryLarge: () => LightVerificationPrimaryLarge_default,
  LightVerificationPrimarySmall: () => LightVerificationPrimarySmall_default,
  LightVerificationSecondaryLarge: () => LightVerificationSecondaryLarge_default,
  LightVerificationSecondarySmall: () => LightVerificationSecondarySmall_default,
  LightVideoPrimaryLarge: () => LightVideoPrimaryLarge_default,
  LightVideoPrimarySmall: () => LightVideoPrimarySmall_default,
  LightVideoSecondaryLarge: () => LightVideoSecondaryLarge_default,
  LightVideoSecondarySmall: () => LightVideoSecondarySmall_default
});

// src/components/LightVideoSecondarySmall.tsx
import * as React from "react";
function LightVideoSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React.createElement("img", {
    alt: "LightVideoSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightVideoSecondarySmall.svg",
    width
  });
}
var LightVideoSecondarySmall_default = LightVideoSecondarySmall;

// src/components/LightVideoPrimarySmall.tsx
import * as React2 from "react";
function LightVideoPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React2.createElement("img", {
    alt: "LightVideoPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightVideoPrimarySmall.svg",
    width
  });
}
var LightVideoPrimarySmall_default = LightVideoPrimarySmall;

// src/components/LightUploadDocSecondarySmall.tsx
import * as React3 from "react";
function LightUploadDocSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React3.createElement("img", {
    alt: "LightUploadDocSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightUploadDocSecondarySmall.svg",
    width
  });
}
var LightUploadDocSecondarySmall_default = LightUploadDocSecondarySmall;

// src/components/LightTrophySecondaryLarge.tsx
import * as React4 from "react";
function LightTrophySecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React4.createElement("img", {
    alt: "LightTrophySecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightTrophySecondaryLarge.svg",
    width
  });
}
var LightTrophySecondaryLarge_default = LightTrophySecondaryLarge;

// src/components/LightVerificationSecondarySmall.tsx
import * as React5 from "react";
function LightVerificationSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React5.createElement("img", {
    alt: "LightVerificationSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightVerificationSecondarySmall.svg",
    width
  });
}
var LightVerificationSecondarySmall_default = LightVerificationSecondarySmall;

// src/components/LightVerificationPrimarySmall.tsx
import * as React6 from "react";
function LightVerificationPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React6.createElement("img", {
    alt: "LightVerificationPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightVerificationPrimarySmall.svg",
    width
  });
}
var LightVerificationPrimarySmall_default = LightVerificationPrimarySmall;

// src/components/LightStatsPrimaryLarge.tsx
import * as React7 from "react";
function LightStatsPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React7.createElement("img", {
    alt: "LightStatsPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStatsPrimaryLarge.svg",
    width
  });
}
var LightStatsPrimaryLarge_default = LightStatsPrimaryLarge;

// src/components/LightVerificationPrimaryLarge.tsx
import * as React8 from "react";
function LightVerificationPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React8.createElement("img", {
    alt: "LightVerificationPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightVerificationPrimaryLarge.svg",
    width
  });
}
var LightVerificationPrimaryLarge_default = LightVerificationPrimaryLarge;

// src/components/LightStrategyPrimaryLarge.tsx
import * as React9 from "react";
function LightStrategyPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React9.createElement("img", {
    alt: "LightStrategyPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStrategyPrimaryLarge.svg",
    width
  });
}
var LightStrategyPrimaryLarge_default = LightStrategyPrimaryLarge;

// src/components/LightVideoSecondaryLarge.tsx
import * as React10 from "react";
function LightVideoSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React10.createElement("img", {
    alt: "LightVideoSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightVideoSecondaryLarge.svg",
    width
  });
}
var LightVideoSecondaryLarge_default = LightVideoSecondaryLarge;

// src/components/LightUploadDocPrimarySmall.tsx
import * as React11 from "react";
function LightUploadDocPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React11.createElement("img", {
    alt: "LightUploadDocPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightUploadDocPrimarySmall.svg",
    width
  });
}
var LightUploadDocPrimarySmall_default = LightUploadDocPrimarySmall;

// src/components/LightVideoPrimaryLarge.tsx
import * as React12 from "react";
function LightVideoPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React12.createElement("img", {
    alt: "LightVideoPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightVideoPrimaryLarge.svg",
    width
  });
}
var LightVideoPrimaryLarge_default = LightVideoPrimaryLarge;

// src/components/LightUploadDocSecondaryLarge.tsx
import * as React13 from "react";
function LightUploadDocSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React13.createElement("img", {
    alt: "LightUploadDocSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightUploadDocSecondaryLarge.svg",
    width
  });
}
var LightUploadDocSecondaryLarge_default = LightUploadDocSecondaryLarge;

// src/components/LightVerificationSecondaryLarge.tsx
import * as React14 from "react";
function LightVerificationSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React14.createElement("img", {
    alt: "LightVerificationSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightVerificationSecondaryLarge.svg",
    width
  });
}
var LightVerificationSecondaryLarge_default = LightVerificationSecondaryLarge;

// src/components/LightStrategySecondarySmall.tsx
import * as React15 from "react";
function LightStrategySecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React15.createElement("img", {
    alt: "LightStrategySecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStrategySecondarySmall.svg",
    width
  });
}
var LightStrategySecondarySmall_default = LightStrategySecondarySmall;

// src/components/LightUploadDocPrimaryLarge.tsx
import * as React16 from "react";
function LightUploadDocPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React16.createElement("img", {
    alt: "LightUploadDocPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightUploadDocPrimaryLarge.svg",
    width
  });
}
var LightUploadDocPrimaryLarge_default = LightUploadDocPrimaryLarge;

// src/components/LightStrategySecondaryLarge.tsx
import * as React17 from "react";
function LightStrategySecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React17.createElement("img", {
    alt: "LightStrategySecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStrategySecondaryLarge.svg",
    width
  });
}
var LightStrategySecondaryLarge_default = LightStrategySecondaryLarge;

// src/components/LightTeamPlayerPrimarySmall.tsx
import * as React18 from "react";
function LightTeamPlayerPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React18.createElement("img", {
    alt: "LightTeamPlayerPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightTeamPlayerPrimarySmall.svg",
    width
  });
}
var LightTeamPlayerPrimarySmall_default = LightTeamPlayerPrimarySmall;

// src/components/LightTeamPlayerSecondaryLarge.tsx
import * as React19 from "react";
function LightTeamPlayerSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React19.createElement("img", {
    alt: "LightTeamPlayerSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightTeamPlayerSecondaryLarge.svg",
    width
  });
}
var LightTeamPlayerSecondaryLarge_default = LightTeamPlayerSecondaryLarge;

// src/components/LightTeamPlayerPrimaryLarge.tsx
import * as React20 from "react";
function LightTeamPlayerPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React20.createElement("img", {
    alt: "LightTeamPlayerPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightTeamPlayerPrimaryLarge.svg",
    width
  });
}
var LightTeamPlayerPrimaryLarge_default = LightTeamPlayerPrimaryLarge;

// src/components/LightTrophyPrimaryLarge.tsx
import * as React21 from "react";
function LightTrophyPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React21.createElement("img", {
    alt: "LightTrophyPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightTrophyPrimaryLarge.svg",
    width
  });
}
var LightTrophyPrimaryLarge_default = LightTrophyPrimaryLarge;

// src/components/LightSportsmanshipPrimaryLarge.tsx
import * as React22 from "react";
function LightSportsmanshipPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React22.createElement("img", {
    alt: "LightSportsmanshipPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightSportsmanshipPrimaryLarge.svg",
    width
  });
}
var LightSportsmanshipPrimaryLarge_default = LightSportsmanshipPrimaryLarge;

// src/components/LightSportsmanshipSecondarySmall.tsx
import * as React23 from "react";
function LightSportsmanshipSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React23.createElement("img", {
    alt: "LightSportsmanshipSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightSportsmanshipSecondarySmall.svg",
    width
  });
}
var LightSportsmanshipSecondarySmall_default = LightSportsmanshipSecondarySmall;

// src/components/LightTeamPlayerSecondarySmall.tsx
import * as React24 from "react";
function LightTeamPlayerSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React24.createElement("img", {
    alt: "LightTeamPlayerSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightTeamPlayerSecondarySmall.svg",
    width
  });
}
var LightTeamPlayerSecondarySmall_default = LightTeamPlayerSecondarySmall;

// src/components/LightTrophySecondarySmall.tsx
import * as React25 from "react";
function LightTrophySecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React25.createElement("img", {
    alt: "LightTrophySecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightTrophySecondarySmall.svg",
    width
  });
}
var LightTrophySecondarySmall_default = LightTrophySecondarySmall;

// src/components/LightStrategyPrimarySmall.tsx
import * as React26 from "react";
function LightStrategyPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React26.createElement("img", {
    alt: "LightStrategyPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStrategyPrimarySmall.svg",
    width
  });
}
var LightStrategyPrimarySmall_default = LightStrategyPrimarySmall;

// src/components/LightStandingSecondaryLarge.tsx
import * as React27 from "react";
function LightStandingSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React27.createElement("img", {
    alt: "LightStandingSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStandingSecondaryLarge.svg",
    width
  });
}
var LightStandingSecondaryLarge_default = LightStandingSecondaryLarge;

// src/components/LightStadiumPrimaryLarge.tsx
import * as React28 from "react";
function LightStadiumPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React28.createElement("img", {
    alt: "LightStadiumPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStadiumPrimaryLarge.svg",
    width
  });
}
var LightStadiumPrimaryLarge_default = LightStadiumPrimaryLarge;

// src/components/LightStatsPrimarySmall.tsx
import * as React29 from "react";
function LightStatsPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React29.createElement("img", {
    alt: "LightStatsPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStatsPrimarySmall.svg",
    width
  });
}
var LightStatsPrimarySmall_default = LightStatsPrimarySmall;

// src/components/LightSportsmanshipSecondaryLarge.tsx
import * as React30 from "react";
function LightSportsmanshipSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React30.createElement("img", {
    alt: "LightSportsmanshipSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightSportsmanshipSecondaryLarge.svg",
    width
  });
}
var LightSportsmanshipSecondaryLarge_default = LightSportsmanshipSecondaryLarge;

// src/components/LightStadiumSecondaryLarge.tsx
import * as React31 from "react";
function LightStadiumSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React31.createElement("img", {
    alt: "LightStadiumSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStadiumSecondaryLarge.svg",
    width
  });
}
var LightStadiumSecondaryLarge_default = LightStadiumSecondaryLarge;

// src/components/LightSchoolSecondarySmall.tsx
import * as React32 from "react";
function LightSchoolSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React32.createElement("img", {
    alt: "LightSchoolSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightSchoolSecondarySmall.svg",
    width
  });
}
var LightSchoolSecondarySmall_default = LightSchoolSecondarySmall;

// src/components/LightStatsSecondarySmall.tsx
import * as React33 from "react";
function LightStatsSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React33.createElement("img", {
    alt: "LightStatsSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStatsSecondarySmall.svg",
    width
  });
}
var LightStatsSecondarySmall_default = LightStatsSecondarySmall;

// src/components/LightStandingSecondarySmall.tsx
import * as React34 from "react";
function LightStandingSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React34.createElement("img", {
    alt: "LightStandingSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStandingSecondarySmall.svg",
    width
  });
}
var LightStandingSecondarySmall_default = LightStandingSecondarySmall;

// src/components/LightSportsmanshipPrimarySmall.tsx
import * as React35 from "react";
function LightSportsmanshipPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React35.createElement("img", {
    alt: "LightSportsmanshipPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightSportsmanshipPrimarySmall.svg",
    width
  });
}
var LightSportsmanshipPrimarySmall_default = LightSportsmanshipPrimarySmall;

// src/components/LightStatsSecondaryLarge.tsx
import * as React36 from "react";
function LightStatsSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React36.createElement("img", {
    alt: "LightStatsSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStatsSecondaryLarge.svg",
    width
  });
}
var LightStatsSecondaryLarge_default = LightStatsSecondaryLarge;

// src/components/LightTrophyPrimarySmall.tsx
import * as React37 from "react";
function LightTrophyPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React37.createElement("img", {
    alt: "LightTrophyPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightTrophyPrimarySmall.svg",
    width
  });
}
var LightTrophyPrimarySmall_default = LightTrophyPrimarySmall;

// src/components/LightStandingPrimarySmall.tsx
import * as React38 from "react";
function LightStandingPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React38.createElement("img", {
    alt: "LightStandingPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStandingPrimarySmall.svg",
    width
  });
}
var LightStandingPrimarySmall_default = LightStandingPrimarySmall;

// src/components/LightSchoolSecondaryLarge.tsx
import * as React39 from "react";
function LightSchoolSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React39.createElement("img", {
    alt: "LightSchoolSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightSchoolSecondaryLarge.svg",
    width
  });
}
var LightSchoolSecondaryLarge_default = LightSchoolSecondaryLarge;

// src/components/LightScheduleSecondarySmall.tsx
import * as React40 from "react";
function LightScheduleSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React40.createElement("img", {
    alt: "LightScheduleSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightScheduleSecondarySmall.svg",
    width
  });
}
var LightScheduleSecondarySmall_default = LightScheduleSecondarySmall;

// src/components/LightStandingPrimaryLarge.tsx
import * as React41 from "react";
function LightStandingPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React41.createElement("img", {
    alt: "LightStandingPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStandingPrimaryLarge.svg",
    width
  });
}
var LightStandingPrimaryLarge_default = LightStandingPrimaryLarge;

// src/components/LightStadiumSecondarySmall.tsx
import * as React42 from "react";
function LightStadiumSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React42.createElement("img", {
    alt: "LightStadiumSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStadiumSecondarySmall.svg",
    width
  });
}
var LightStadiumSecondarySmall_default = LightStadiumSecondarySmall;

// src/components/LightStadiumPrimarySmall.tsx
import * as React43 from "react";
function LightStadiumPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React43.createElement("img", {
    alt: "LightStadiumPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightStadiumPrimarySmall.svg",
    width
  });
}
var LightStadiumPrimarySmall_default = LightStadiumPrimarySmall;

// src/components/LightHighAlertPrimarySmall.tsx
import * as React44 from "react";
function LightHighAlertPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React44.createElement("img", {
    alt: "LightHighAlertPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightHighAlertPrimarySmall.svg",
    width
  });
}
var LightHighAlertPrimarySmall_default = LightHighAlertPrimarySmall;

// src/components/LightMoneySecondarySmall.tsx
import * as React45 from "react";
function LightMoneySecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React45.createElement("img", {
    alt: "LightMoneySecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMoneySecondarySmall.svg",
    width
  });
}
var LightMoneySecondarySmall_default = LightMoneySecondarySmall;

// src/components/LightSchoolPrimarySmall.tsx
import * as React46 from "react";
function LightSchoolPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React46.createElement("img", {
    alt: "LightSchoolPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightSchoolPrimarySmall.svg",
    width
  });
}
var LightSchoolPrimarySmall_default = LightSchoolPrimarySmall;

// src/components/LightNotVerifiedSecondarySmall.tsx
import * as React47 from "react";
function LightNotVerifiedSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React47.createElement("img", {
    alt: "LightNotVerifiedSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightNotVerifiedSecondarySmall.svg",
    width
  });
}
var LightNotVerifiedSecondarySmall_default = LightNotVerifiedSecondarySmall;

// src/components/LightResourcesSecondaryLarge.tsx
import * as React48 from "react";
function LightResourcesSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React48.createElement("img", {
    alt: "LightResourcesSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightResourcesSecondaryLarge.svg",
    width
  });
}
var LightResourcesSecondaryLarge_default = LightResourcesSecondaryLarge;

// src/components/LightSchoolPrimaryLarge.tsx
import * as React49 from "react";
function LightSchoolPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React49.createElement("img", {
    alt: "LightSchoolPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightSchoolPrimaryLarge.svg",
    width
  });
}
var LightSchoolPrimaryLarge_default = LightSchoolPrimaryLarge;

// src/components/LightResourcesSecondarySmall.tsx
import * as React50 from "react";
function LightResourcesSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React50.createElement("img", {
    alt: "LightResourcesSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightResourcesSecondarySmall.svg",
    width
  });
}
var LightResourcesSecondarySmall_default = LightResourcesSecondarySmall;

// src/components/LightScheduleSecondaryLarge.tsx
import * as React51 from "react";
function LightScheduleSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React51.createElement("img", {
    alt: "LightScheduleSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightScheduleSecondaryLarge.svg",
    width
  });
}
var LightScheduleSecondaryLarge_default = LightScheduleSecondaryLarge;

// src/components/LightKeyboardPrimaryLarge.tsx
import * as React52 from "react";
function LightKeyboardPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React52.createElement("img", {
    alt: "LightKeyboardPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightKeyboardPrimaryLarge.svg",
    width
  });
}
var LightKeyboardPrimaryLarge_default = LightKeyboardPrimaryLarge;

// src/components/LightPassSecondarySmall.tsx
import * as React53 from "react";
function LightPassSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React53.createElement("img", {
    alt: "LightPassSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightPassSecondarySmall.svg",
    width
  });
}
var LightPassSecondarySmall_default = LightPassSecondarySmall;

// src/components/LightSchedulePrimarySmall.tsx
import * as React54 from "react";
function LightSchedulePrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React54.createElement("img", {
    alt: "LightSchedulePrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightSchedulePrimarySmall.svg",
    width
  });
}
var LightSchedulePrimarySmall_default = LightSchedulePrimarySmall;

// src/components/LightRewardPrimarySmall.tsx
import * as React55 from "react";
function LightRewardPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React55.createElement("img", {
    alt: "LightRewardPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightRewardPrimarySmall.svg",
    width
  });
}
var LightRewardPrimarySmall_default = LightRewardPrimarySmall;

// src/components/LightSchedulePrimaryLarge.tsx
import * as React56 from "react";
function LightSchedulePrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React56.createElement("img", {
    alt: "LightSchedulePrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightSchedulePrimaryLarge.svg",
    width
  });
}
var LightSchedulePrimaryLarge_default = LightSchedulePrimaryLarge;

// src/components/LightRewardSecondaryLarge.tsx
import * as React57 from "react";
function LightRewardSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React57.createElement("img", {
    alt: "LightRewardSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightRewardSecondaryLarge.svg",
    width
  });
}
var LightRewardSecondaryLarge_default = LightRewardSecondaryLarge;

// src/components/LightNotVerifiedPrimarySmall.tsx
import * as React58 from "react";
function LightNotVerifiedPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React58.createElement("img", {
    alt: "LightNotVerifiedPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightNotVerifiedPrimarySmall.svg",
    width
  });
}
var LightNotVerifiedPrimarySmall_default = LightNotVerifiedPrimarySmall;

// src/components/LightPendingPrimarySmall.tsx
import * as React59 from "react";
function LightPendingPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React59.createElement("img", {
    alt: "LightPendingPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightPendingPrimarySmall.svg",
    width
  });
}
var LightPendingPrimarySmall_default = LightPendingPrimarySmall;

// src/components/LightRewardSecondarySmall.tsx
import * as React60 from "react";
function LightRewardSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React60.createElement("img", {
    alt: "LightRewardSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightRewardSecondarySmall.svg",
    width
  });
}
var LightRewardSecondarySmall_default = LightRewardSecondarySmall;

// src/components/LightPassPrimaryLarge.tsx
import * as React61 from "react";
function LightPassPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React61.createElement("img", {
    alt: "LightPassPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightPassPrimaryLarge.svg",
    width
  });
}
var LightPassPrimaryLarge_default = LightPassPrimaryLarge;

// src/components/LightResourcesPrimaryLarge.tsx
import * as React62 from "react";
function LightResourcesPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React62.createElement("img", {
    alt: "LightResourcesPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightResourcesPrimaryLarge.svg",
    width
  });
}
var LightResourcesPrimaryLarge_default = LightResourcesPrimaryLarge;

// src/components/LightResourcesPrimaryMedium.tsx
import * as React63 from "react";
function LightResourcesPrimaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React63.createElement("img", {
    alt: "LightResourcesPrimaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightResourcesPrimaryMedium.svg",
    width
  });
}
var LightResourcesPrimaryMedium_default = LightResourcesPrimaryMedium;

// src/components/LightResourcesSecondaryMedium.tsx
import * as React64 from "react";
function LightResourcesSecondaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React64.createElement("img", {
    alt: "LightResourcesSecondaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightResourcesSecondaryMedium.svg",
    width
  });
}
var LightResourcesSecondaryMedium_default = LightResourcesSecondaryMedium;

// src/components/LightPendingSecondaryLarge.tsx
import * as React65 from "react";
function LightPendingSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React65.createElement("img", {
    alt: "LightPendingSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightPendingSecondaryLarge.svg",
    width
  });
}
var LightPendingSecondaryLarge_default = LightPendingSecondaryLarge;

// src/components/LightPassSecondaryLarge.tsx
import * as React66 from "react";
function LightPassSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React66.createElement("img", {
    alt: "LightPassSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightPassSecondaryLarge.svg",
    width
  });
}
var LightPassSecondaryLarge_default = LightPassSecondaryLarge;

// src/components/LightResourcesPrimarySmall.tsx
import * as React67 from "react";
function LightResourcesPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React67.createElement("img", {
    alt: "LightResourcesPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightResourcesPrimarySmall.svg",
    width
  });
}
var LightResourcesPrimarySmall_default = LightResourcesPrimarySmall;

// src/components/LightRewardPrimaryLarge.tsx
import * as React68 from "react";
function LightRewardPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React68.createElement("img", {
    alt: "LightRewardPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightRewardPrimaryLarge.svg",
    width
  });
}
var LightRewardPrimaryLarge_default = LightRewardPrimaryLarge;

// src/components/LightPassPrimarySmall.tsx
import * as React69 from "react";
function LightPassPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React69.createElement("img", {
    alt: "LightPassPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightPassPrimarySmall.svg",
    width
  });
}
var LightPassPrimarySmall_default = LightPassPrimarySmall;

// src/components/LightPendingSecondarySmall.tsx
import * as React70 from "react";
function LightPendingSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React70.createElement("img", {
    alt: "LightPendingSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightPendingSecondarySmall.svg",
    width
  });
}
var LightPendingSecondarySmall_default = LightPendingSecondarySmall;

// src/components/LightNotVerifiedSecondaryLarge.tsx
import * as React71 from "react";
function LightNotVerifiedSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React71.createElement("img", {
    alt: "LightNotVerifiedSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightNotVerifiedSecondaryLarge.svg",
    width
  });
}
var LightNotVerifiedSecondaryLarge_default = LightNotVerifiedSecondaryLarge;

// src/components/LightMegaphoneSecondarySmall.tsx
import * as React72 from "react";
function LightMegaphoneSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React72.createElement("img", {
    alt: "LightMegaphoneSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMegaphoneSecondarySmall.svg",
    width
  });
}
var LightMegaphoneSecondarySmall_default = LightMegaphoneSecondarySmall;

// src/components/LightPendingPrimaryLarge.tsx
import * as React73 from "react";
function LightPendingPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React73.createElement("img", {
    alt: "LightPendingPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightPendingPrimaryLarge.svg",
    width
  });
}
var LightPendingPrimaryLarge_default = LightPendingPrimaryLarge;

// src/components/LightMegaphoneSecondaryLarge.tsx
import * as React74 from "react";
function LightMegaphoneSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React74.createElement("img", {
    alt: "LightMegaphoneSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMegaphoneSecondaryLarge.svg",
    width
  });
}
var LightMegaphoneSecondaryLarge_default = LightMegaphoneSecondaryLarge;

// src/components/LightMoneyPrimarySmall.tsx
import * as React75 from "react";
function LightMoneyPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React75.createElement("img", {
    alt: "LightMoneyPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMoneyPrimarySmall.svg",
    width
  });
}
var LightMoneyPrimarySmall_default = LightMoneyPrimarySmall;

// src/components/LightMegaphonePrimarySmall.tsx
import * as React76 from "react";
function LightMegaphonePrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React76.createElement("img", {
    alt: "LightMegaphonePrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMegaphonePrimarySmall.svg",
    width
  });
}
var LightMegaphonePrimarySmall_default = LightMegaphonePrimarySmall;

// src/components/LightNotVerifiedPrimaryLarge.tsx
import * as React77 from "react";
function LightNotVerifiedPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React77.createElement("img", {
    alt: "LightNotVerifiedPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightNotVerifiedPrimaryLarge.svg",
    width
  });
}
var LightNotVerifiedPrimaryLarge_default = LightNotVerifiedPrimaryLarge;

// src/components/LightNotificationPrimarySmall.tsx
import * as React78 from "react";
function LightNotificationPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React78.createElement("img", {
    alt: "LightNotificationPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightNotificationPrimarySmall.svg",
    width
  });
}
var LightNotificationPrimarySmall_default = LightNotificationPrimarySmall;

// src/components/LightMouseSecondarySmall.tsx
import * as React79 from "react";
function LightMouseSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React79.createElement("img", {
    alt: "LightMouseSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMouseSecondarySmall.svg",
    width
  });
}
var LightMouseSecondarySmall_default = LightMouseSecondarySmall;

// src/components/LightNotificationSecondarySmall.tsx
import * as React80 from "react";
function LightNotificationSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React80.createElement("img", {
    alt: "LightNotificationSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightNotificationSecondarySmall.svg",
    width
  });
}
var LightNotificationSecondarySmall_default = LightNotificationSecondarySmall;

// src/components/LightMousePrimaryLarge.tsx
import * as React81 from "react";
function LightMousePrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React81.createElement("img", {
    alt: "LightMousePrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMousePrimaryLarge.svg",
    width
  });
}
var LightMousePrimaryLarge_default = LightMousePrimaryLarge;

// src/components/LightMoneyPrimaryLarge.tsx
import * as React82 from "react";
function LightMoneyPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React82.createElement("img", {
    alt: "LightMoneyPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMoneyPrimaryLarge.svg",
    width
  });
}
var LightMoneyPrimaryLarge_default = LightMoneyPrimaryLarge;

// src/components/LightLeaguePrimarySmall.tsx
import * as React83 from "react";
function LightLeaguePrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React83.createElement("img", {
    alt: "LightLeaguePrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightLeaguePrimarySmall.svg",
    width
  });
}
var LightLeaguePrimarySmall_default = LightLeaguePrimarySmall;

// src/components/LightFoamFingerSecondaryLarge.tsx
import * as React84 from "react";
function LightFoamFingerSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React84.createElement("img", {
    alt: "LightFoamFingerSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightFoamFingerSecondaryLarge.svg",
    width
  });
}
var LightFoamFingerSecondaryLarge_default = LightFoamFingerSecondaryLarge;

// src/components/LightMouseSecondaryLarge.tsx
import * as React85 from "react";
function LightMouseSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React85.createElement("img", {
    alt: "LightMouseSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMouseSecondaryLarge.svg",
    width
  });
}
var LightMouseSecondaryLarge_default = LightMouseSecondaryLarge;

// src/components/LightNotificationPrimaryLarge.tsx
import * as React86 from "react";
function LightNotificationPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React86.createElement("img", {
    alt: "LightNotificationPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightNotificationPrimaryLarge.svg",
    width
  });
}
var LightNotificationPrimaryLarge_default = LightNotificationPrimaryLarge;

// src/components/LightKeyboardSecondarySmall.tsx
import * as React87 from "react";
function LightKeyboardSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React87.createElement("img", {
    alt: "LightKeyboardSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightKeyboardSecondarySmall.svg",
    width
  });
}
var LightKeyboardSecondarySmall_default = LightKeyboardSecondarySmall;

// src/components/LightMegaphonePrimaryLarge.tsx
import * as React88 from "react";
function LightMegaphonePrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React88.createElement("img", {
    alt: "LightMegaphonePrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMegaphonePrimaryLarge.svg",
    width
  });
}
var LightMegaphonePrimaryLarge_default = LightMegaphonePrimaryLarge;

// src/components/LightMousePrimarySmall.tsx
import * as React89 from "react";
function LightMousePrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React89.createElement("img", {
    alt: "LightMousePrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMousePrimarySmall.svg",
    width
  });
}
var LightMousePrimarySmall_default = LightMousePrimarySmall;

// src/components/LightMoneySecondaryLarge.tsx
import * as React90 from "react";
function LightMoneySecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React90.createElement("img", {
    alt: "LightMoneySecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightMoneySecondaryLarge.svg",
    width
  });
}
var LightMoneySecondaryLarge_default = LightMoneySecondaryLarge;

// src/components/LightKeyboardPrimarySmall.tsx
import * as React91 from "react";
function LightKeyboardPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React91.createElement("img", {
    alt: "LightKeyboardPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightKeyboardPrimarySmall.svg",
    width
  });
}
var LightKeyboardPrimarySmall_default = LightKeyboardPrimarySmall;

// src/components/LightLeagueSecondaryLarge.tsx
import * as React92 from "react";
function LightLeagueSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React92.createElement("img", {
    alt: "LightLeagueSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightLeagueSecondaryLarge.svg",
    width
  });
}
var LightLeagueSecondaryLarge_default = LightLeagueSecondaryLarge;

// src/components/LightKeyboardSecondaryLarge.tsx
import * as React93 from "react";
function LightKeyboardSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React93.createElement("img", {
    alt: "LightKeyboardSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightKeyboardSecondaryLarge.svg",
    width
  });
}
var LightKeyboardSecondaryLarge_default = LightKeyboardSecondaryLarge;

// src/components/LightFlagsLightPrimarySmall.tsx
import * as React94 from "react";
function LightFlagsLightPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React94.createElement("img", {
    alt: "LightFlagsLightPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightFlagsLightPrimarySmall.svg",
    width
  });
}
var LightFlagsLightPrimarySmall_default = LightFlagsLightPrimarySmall;

// src/components/LightFoamFingerPrimaryLarge.tsx
import * as React95 from "react";
function LightFoamFingerPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React95.createElement("img", {
    alt: "LightFoamFingerPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightFoamFingerPrimaryLarge.svg",
    width
  });
}
var LightFoamFingerPrimaryLarge_default = LightFoamFingerPrimaryLarge;

// src/components/LightLeagueSecondarySmall.tsx
import * as React96 from "react";
function LightLeagueSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React96.createElement("img", {
    alt: "LightLeagueSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightLeagueSecondarySmall.svg",
    width
  });
}
var LightLeagueSecondarySmall_default = LightLeagueSecondarySmall;

// src/components/LightLeaguePrimaryLarge.tsx
import * as React97 from "react";
function LightLeaguePrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React97.createElement("img", {
    alt: "LightLeaguePrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightLeaguePrimaryLarge.svg",
    width
  });
}
var LightLeaguePrimaryLarge_default = LightLeaguePrimaryLarge;

// src/components/LightFlagsLightSecondarySmall.tsx
import * as React98 from "react";
function LightFlagsLightSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React98.createElement("img", {
    alt: "LightFlagsLightSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightFlagsLightSecondarySmall.svg",
    width
  });
}
var LightFlagsLightSecondarySmall_default = LightFlagsLightSecondarySmall;

// src/components/LightHighAlertSecondarySmall.tsx
import * as React99 from "react";
function LightHighAlertSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React99.createElement("img", {
    alt: "LightHighAlertSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightHighAlertSecondarySmall.svg",
    width
  });
}
var LightHighAlertSecondarySmall_default = LightHighAlertSecondarySmall;

// src/components/LightInvitePlayersPrimarySmall.tsx
import * as React100 from "react";
function LightInvitePlayersPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React100.createElement("img", {
    alt: "LightInvitePlayersPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightInvitePlayersPrimarySmall.svg",
    width
  });
}
var LightInvitePlayersPrimarySmall_default = LightInvitePlayersPrimarySmall;

// src/components/LightInvitePlayersSecondarySmall.tsx
import * as React101 from "react";
function LightInvitePlayersSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React101.createElement("img", {
    alt: "LightInvitePlayersSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightInvitePlayersSecondarySmall.svg",
    width
  });
}
var LightInvitePlayersSecondarySmall_default = LightInvitePlayersSecondarySmall;

// src/components/LightCreateTeamSecondaryLarge.tsx
import * as React102 from "react";
function LightCreateTeamSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React102.createElement("img", {
    alt: "LightCreateTeamSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCreateTeamSecondaryLarge.svg",
    width
  });
}
var LightCreateTeamSecondaryLarge_default = LightCreateTeamSecondaryLarge;

// src/components/LightCheckboxSecondaryLarge.tsx
import * as React103 from "react";
function LightCheckboxSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React103.createElement("img", {
    alt: "LightCheckboxSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCheckboxSecondaryLarge.svg",
    width
  });
}
var LightCheckboxSecondaryLarge_default = LightCheckboxSecondaryLarge;

// src/components/LightInvitePlayersPrimaryLarge.tsx
import * as React104 from "react";
function LightInvitePlayersPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React104.createElement("img", {
    alt: "LightInvitePlayersPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightInvitePlayersPrimaryLarge.svg",
    width
  });
}
var LightInvitePlayersPrimaryLarge_default = LightInvitePlayersPrimaryLarge;

// src/components/LightInvitePlayersSecondaryLarge.tsx
import * as React105 from "react";
function LightInvitePlayersSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React105.createElement("img", {
    alt: "LightInvitePlayersSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightInvitePlayersSecondaryLarge.svg",
    width
  });
}
var LightInvitePlayersSecondaryLarge_default = LightInvitePlayersSecondaryLarge;

// src/components/LightGraduationHatPrimarySmall.tsx
import * as React106 from "react";
function LightGraduationHatPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React106.createElement("img", {
    alt: "LightGraduationHatPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightGraduationHatPrimarySmall.svg",
    width
  });
}
var LightGraduationHatPrimarySmall_default = LightGraduationHatPrimarySmall;

// src/components/LightHighAlertSecondaryLarge.tsx
import * as React107 from "react";
function LightHighAlertSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React107.createElement("img", {
    alt: "LightHighAlertSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightHighAlertSecondaryLarge.svg",
    width
  });
}
var LightHighAlertSecondaryLarge_default = LightHighAlertSecondaryLarge;

// src/components/LightFoamFingerSecondarySmall.tsx
import * as React108 from "react";
function LightFoamFingerSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React108.createElement("img", {
    alt: "LightFoamFingerSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightFoamFingerSecondarySmall.svg",
    width
  });
}
var LightFoamFingerSecondarySmall_default = LightFoamFingerSecondarySmall;

// src/components/LightFoamFingerPrimarySmall.tsx
import * as React109 from "react";
function LightFoamFingerPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React109.createElement("img", {
    alt: "LightFoamFingerPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightFoamFingerPrimarySmall.svg",
    width
  });
}
var LightFoamFingerPrimarySmall_default = LightFoamFingerPrimarySmall;

// src/components/LightFlagsLightSecondaryLarge.tsx
import * as React110 from "react";
function LightFlagsLightSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React110.createElement("img", {
    alt: "LightFlagsLightSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightFlagsLightSecondaryLarge.svg",
    width
  });
}
var LightFlagsLightSecondaryLarge_default = LightFlagsLightSecondaryLarge;

// src/components/LightGraduationHatSecondarySmall.tsx
import * as React111 from "react";
function LightGraduationHatSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React111.createElement("img", {
    alt: "LightGraduationHatSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightGraduationHatSecondarySmall.svg",
    width
  });
}
var LightGraduationHatSecondarySmall_default = LightGraduationHatSecondarySmall;

// src/components/LightGraduationHatPrimaryLarge.tsx
import * as React112 from "react";
function LightGraduationHatPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React112.createElement("img", {
    alt: "LightGraduationHatPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightGraduationHatPrimaryLarge.svg",
    width
  });
}
var LightGraduationHatPrimaryLarge_default = LightGraduationHatPrimaryLarge;

// src/components/LightEnrollmentSecondarySmall.tsx
import * as React113 from "react";
function LightEnrollmentSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React113.createElement("img", {
    alt: "LightEnrollmentSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightEnrollmentSecondarySmall.svg",
    width
  });
}
var LightEnrollmentSecondarySmall_default = LightEnrollmentSecondarySmall;

// src/components/LightHighAlertPrimaryLarge.tsx
import * as React114 from "react";
function LightHighAlertPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React114.createElement("img", {
    alt: "LightHighAlertPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightHighAlertPrimaryLarge.svg",
    width
  });
}
var LightHighAlertPrimaryLarge_default = LightHighAlertPrimaryLarge;

// src/components/LightFlagsLightPrimaryLarge.tsx
import * as React115 from "react";
function LightFlagsLightPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React115.createElement("img", {
    alt: "LightFlagsLightPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightFlagsLightPrimaryLarge.svg",
    width
  });
}
var LightFlagsLightPrimaryLarge_default = LightFlagsLightPrimaryLarge;

// src/components/LightConnectionSecondaryLarge.tsx
import * as React116 from "react";
function LightConnectionSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React116.createElement("img", {
    alt: "LightConnectionSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConnectionSecondaryLarge.svg",
    width
  });
}
var LightConnectionSecondaryLarge_default = LightConnectionSecondaryLarge;

// src/components/LightEnrollmentPrimarySmall.tsx
import * as React117 from "react";
function LightEnrollmentPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React117.createElement("img", {
    alt: "LightEnrollmentPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightEnrollmentPrimarySmall.svg",
    width
  });
}
var LightEnrollmentPrimarySmall_default = LightEnrollmentPrimarySmall;

// src/components/LightGraduationHatSecondaryLarge.tsx
import * as React118 from "react";
function LightGraduationHatSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React118.createElement("img", {
    alt: "LightGraduationHatSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightGraduationHatSecondaryLarge.svg",
    width
  });
}
var LightGraduationHatSecondaryLarge_default = LightGraduationHatSecondaryLarge;

// src/components/LightBillingPrimaryLarge.tsx
import * as React119 from "react";
function LightBillingPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React119.createElement("img", {
    alt: "LightBillingPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightBillingPrimaryLarge.svg",
    width
  });
}
var LightBillingPrimaryLarge_default = LightBillingPrimaryLarge;

// src/components/LightEmailVerificationSecondaryLarge.tsx
import * as React120 from "react";
function LightEmailVerificationSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React120.createElement("img", {
    alt: "LightEmailVerificationSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightEmailVerificationSecondaryLarge.svg",
    width
  });
}
var LightEmailVerificationSecondaryLarge_default = LightEmailVerificationSecondaryLarge;

// src/components/LightEmailVerificationPrimaryLarge.tsx
import * as React121 from "react";
function LightEmailVerificationPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React121.createElement("img", {
    alt: "LightEmailVerificationPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightEmailVerificationPrimaryLarge.svg",
    width
  });
}
var LightEmailVerificationPrimaryLarge_default = LightEmailVerificationPrimaryLarge;

// src/components/LightEmailVerificationPrimarySmall.tsx
import * as React122 from "react";
function LightEmailVerificationPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React122.createElement("img", {
    alt: "LightEmailVerificationPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightEmailVerificationPrimarySmall.svg",
    width
  });
}
var LightEmailVerificationPrimarySmall_default = LightEmailVerificationPrimarySmall;

// src/components/LightCrownPrimaryLarge.tsx
import * as React123 from "react";
function LightCrownPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React123.createElement("img", {
    alt: "LightCrownPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCrownPrimaryLarge.svg",
    width
  });
}
var LightCrownPrimaryLarge_default = LightCrownPrimaryLarge;

// src/components/LightAwardPrimaryLarge.tsx
import * as React124 from "react";
function LightAwardPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React124.createElement("img", {
    alt: "LightAwardPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightAwardPrimaryLarge.svg",
    width
  });
}
var LightAwardPrimaryLarge_default = LightAwardPrimaryLarge;

// src/components/LightCrownSecondarySmall.tsx
import * as React125 from "react";
function LightCrownSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React125.createElement("img", {
    alt: "LightCrownSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCrownSecondarySmall.svg",
    width
  });
}
var LightCrownSecondarySmall_default = LightCrownSecondarySmall;

// src/components/LightErrorStateLarge.tsx
import * as React126 from "react";
function LightErrorStateLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React126.createElement("img", {
    alt: "LightErrorStateLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightErrorStateLarge.svg",
    width
  });
}
var LightErrorStateLarge_default = LightErrorStateLarge;

// src/components/LightCourseSecondaryLarge.tsx
import * as React127 from "react";
function LightCourseSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React127.createElement("img", {
    alt: "LightCourseSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCourseSecondaryLarge.svg",
    width
  });
}
var LightCourseSecondaryLarge_default = LightCourseSecondaryLarge;

// src/components/LightCoursePrimarySmall.tsx
import * as React128 from "react";
function LightCoursePrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React128.createElement("img", {
    alt: "LightCoursePrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCoursePrimarySmall.svg",
    width
  });
}
var LightCoursePrimarySmall_default = LightCoursePrimarySmall;

// src/components/LightEmailVerificationSecondarySmall.tsx
import * as React129 from "react";
function LightEmailVerificationSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React129.createElement("img", {
    alt: "LightEmailVerificationSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightEmailVerificationSecondarySmall.svg",
    width
  });
}
var LightEmailVerificationSecondarySmall_default = LightEmailVerificationSecondarySmall;

// src/components/LightCrownSecondaryLarge.tsx
import * as React130 from "react";
function LightCrownSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React130.createElement("img", {
    alt: "LightCrownSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCrownSecondaryLarge.svg",
    width
  });
}
var LightCrownSecondaryLarge_default = LightCrownSecondaryLarge;

// src/components/LightConnectedAccountsSecondaryLarge.tsx
import * as React131 from "react";
function LightConnectedAccountsSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React131.createElement("img", {
    alt: "LightConnectedAccountsSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConnectedAccountsSecondaryLarge.svg",
    width
  });
}
var LightConnectedAccountsSecondaryLarge_default = LightConnectedAccountsSecondaryLarge;

// src/components/LightCheckboxSecondarySmall.tsx
import * as React132 from "react";
function LightCheckboxSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React132.createElement("img", {
    alt: "LightCheckboxSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCheckboxSecondarySmall.svg",
    width
  });
}
var LightCheckboxSecondarySmall_default = LightCheckboxSecondarySmall;

// src/components/LightConnectionPrimaryLarge.tsx
import * as React133 from "react";
function LightConnectionPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React133.createElement("img", {
    alt: "LightConnectionPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConnectionPrimaryLarge.svg",
    width
  });
}
var LightConnectionPrimaryLarge_default = LightConnectionPrimaryLarge;

// src/components/LightEnrollmentSecondaryLarge.tsx
import * as React134 from "react";
function LightEnrollmentSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React134.createElement("img", {
    alt: "LightEnrollmentSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightEnrollmentSecondaryLarge.svg",
    width
  });
}
var LightEnrollmentSecondaryLarge_default = LightEnrollmentSecondaryLarge;

// src/components/LightCourseSecondarySmall.tsx
import * as React135 from "react";
function LightCourseSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React135.createElement("img", {
    alt: "LightCourseSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCourseSecondarySmall.svg",
    width
  });
}
var LightCourseSecondarySmall_default = LightCourseSecondarySmall;

// src/components/LightConnectedAccountsSecondarySmall.tsx
import * as React136 from "react";
function LightConnectedAccountsSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React136.createElement("img", {
    alt: "LightConnectedAccountsSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConnectedAccountsSecondarySmall.svg",
    width
  });
}
var LightConnectedAccountsSecondarySmall_default = LightConnectedAccountsSecondarySmall;

// src/components/LightConnectedAccountsPrimaryLarge.tsx
import * as React137 from "react";
function LightConnectedAccountsPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React137.createElement("img", {
    alt: "LightConnectedAccountsPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConnectedAccountsPrimaryLarge.svg",
    width
  });
}
var LightConnectedAccountsPrimaryLarge_default = LightConnectedAccountsPrimaryLarge;

// src/components/LightCoursePrimaryLarge.tsx
import * as React138 from "react";
function LightCoursePrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React138.createElement("img", {
    alt: "LightCoursePrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCoursePrimaryLarge.svg",
    width
  });
}
var LightCoursePrimaryLarge_default = LightCoursePrimaryLarge;

// src/components/LightConnectedAccountsPrimarySmall.tsx
import * as React139 from "react";
function LightConnectedAccountsPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React139.createElement("img", {
    alt: "LightConnectedAccountsPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConnectedAccountsPrimarySmall.svg",
    width
  });
}
var LightConnectedAccountsPrimarySmall_default = LightConnectedAccountsPrimarySmall;

// src/components/LightCrownPrimarySmall.tsx
import * as React140 from "react";
function LightCrownPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React140.createElement("img", {
    alt: "LightCrownPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCrownPrimarySmall.svg",
    width
  });
}
var LightCrownPrimarySmall_default = LightCrownPrimarySmall;

// src/components/LightEnrollmentPrimaryLarge.tsx
import * as React141 from "react";
function LightEnrollmentPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React141.createElement("img", {
    alt: "LightEnrollmentPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightEnrollmentPrimaryLarge.svg",
    width
  });
}
var LightEnrollmentPrimaryLarge_default = LightEnrollmentPrimaryLarge;

// src/components/LightConnectionPrimarySmall.tsx
import * as React142 from "react";
function LightConnectionPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React142.createElement("img", {
    alt: "LightConnectionPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConnectionPrimarySmall.svg",
    width
  });
}
var LightConnectionPrimarySmall_default = LightConnectionPrimarySmall;

// src/components/LightConnectionSecondarySmall.tsx
import * as React143 from "react";
function LightConnectionSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React143.createElement("img", {
    alt: "LightConnectionSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConnectionSecondarySmall.svg",
    width
  });
}
var LightConnectionSecondarySmall_default = LightConnectionSecondarySmall;

// src/components/LightCreateTeamPrimarySmall.tsx
import * as React144 from "react";
function LightCreateTeamPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React144.createElement("img", {
    alt: "LightCreateTeamPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCreateTeamPrimarySmall.svg",
    width
  });
}
var LightCreateTeamPrimarySmall_default = LightCreateTeamPrimarySmall;

// src/components/LightCreateTeamSecondarySmall.tsx
import * as React145 from "react";
function LightCreateTeamSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React145.createElement("img", {
    alt: "LightCreateTeamSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCreateTeamSecondarySmall.svg",
    width
  });
}
var LightCreateTeamSecondarySmall_default = LightCreateTeamSecondarySmall;

// src/components/LightCoachPrimaryLarge.tsx
import * as React146 from "react";
function LightCoachPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React146.createElement("img", {
    alt: "LightCoachPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCoachPrimaryLarge.svg",
    width
  });
}
var LightCoachPrimaryLarge_default = LightCoachPrimaryLarge;

// src/components/LightCreateTeamPrimaryLarge.tsx
import * as React147 from "react";
function LightCreateTeamPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React147.createElement("img", {
    alt: "LightCreateTeamPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCreateTeamPrimaryLarge.svg",
    width
  });
}
var LightCreateTeamPrimaryLarge_default = LightCreateTeamPrimaryLarge;

// src/components/LightCheckboxPrimaryLarge.tsx
import * as React148 from "react";
function LightCheckboxPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React148.createElement("img", {
    alt: "LightCheckboxPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCheckboxPrimaryLarge.svg",
    width
  });
}
var LightCheckboxPrimaryLarge_default = LightCheckboxPrimaryLarge;

// src/components/LightCharacterSelectPrimarySmall.tsx
import * as React149 from "react";
function LightCharacterSelectPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React149.createElement("img", {
    alt: "LightCharacterSelectPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCharacterSelectPrimarySmall.svg",
    width
  });
}
var LightCharacterSelectPrimarySmall_default = LightCharacterSelectPrimarySmall;

// src/components/LightCoachPrimarySmall.tsx
import * as React150 from "react";
function LightCoachPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React150.createElement("img", {
    alt: "LightCoachPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCoachPrimarySmall.svg",
    width
  });
}
var LightCoachPrimarySmall_default = LightCoachPrimarySmall;

// src/components/LightCharacterSelectSecondaryLarge.tsx
import * as React151 from "react";
function LightCharacterSelectSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React151.createElement("img", {
    alt: "LightCharacterSelectSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCharacterSelectSecondaryLarge.svg",
    width
  });
}
var LightCharacterSelectSecondaryLarge_default = LightCharacterSelectSecondaryLarge;

// src/components/LightBillingPrimarySmall.tsx
import * as React152 from "react";
function LightBillingPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React152.createElement("img", {
    alt: "LightBillingPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightBillingPrimarySmall.svg",
    width
  });
}
var LightBillingPrimarySmall_default = LightBillingPrimarySmall;

// src/components/LightBillingSecondaryLarge.tsx
import * as React153 from "react";
function LightBillingSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React153.createElement("img", {
    alt: "LightBillingSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightBillingSecondaryLarge.svg",
    width
  });
}
var LightBillingSecondaryLarge_default = LightBillingSecondaryLarge;

// src/components/LightCoachSecondaryLarge.tsx
import * as React154 from "react";
function LightCoachSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React154.createElement("img", {
    alt: "LightCoachSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCoachSecondaryLarge.svg",
    width
  });
}
var LightCoachSecondaryLarge_default = LightCoachSecondaryLarge;

// src/components/LightCaptainSecondarySmall.tsx
import * as React155 from "react";
function LightCaptainSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React155.createElement("img", {
    alt: "LightCaptainSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCaptainSecondarySmall.svg",
    width
  });
}
var LightCaptainSecondarySmall_default = LightCaptainSecondarySmall;

// src/components/LightArenaPrimarySmall.tsx
import * as React156 from "react";
function LightArenaPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React156.createElement("img", {
    alt: "LightArenaPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightArenaPrimarySmall.svg",
    width
  });
}
var LightArenaPrimarySmall_default = LightArenaPrimarySmall;

// src/components/LightArenaSecondarySmall.tsx
import * as React157 from "react";
function LightArenaSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React157.createElement("img", {
    alt: "LightArenaSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightArenaSecondarySmall.svg",
    width
  });
}
var LightArenaSecondarySmall_default = LightArenaSecondarySmall;

// src/components/LightChatPrimarySmall.tsx
import * as React158 from "react";
function LightChatPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React158.createElement("img", {
    alt: "LightChatPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightChatPrimarySmall.svg",
    width
  });
}
var LightChatPrimarySmall_default = LightChatPrimarySmall;

// src/components/LightCaptainPrimaryLarge.tsx
import * as React159 from "react";
function LightCaptainPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React159.createElement("img", {
    alt: "LightCaptainPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCaptainPrimaryLarge.svg",
    width
  });
}
var LightCaptainPrimaryLarge_default = LightCaptainPrimaryLarge;

// src/components/LightCharacterSelectSecondarySmall.tsx
import * as React160 from "react";
function LightCharacterSelectSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React160.createElement("img", {
    alt: "LightCharacterSelectSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCharacterSelectSecondarySmall.svg",
    width
  });
}
var LightCharacterSelectSecondarySmall_default = LightCharacterSelectSecondarySmall;

// src/components/LightCheckboxPrimarySmall.tsx
import * as React161 from "react";
function LightCheckboxPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React161.createElement("img", {
    alt: "LightCheckboxPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCheckboxPrimarySmall.svg",
    width
  });
}
var LightCheckboxPrimarySmall_default = LightCheckboxPrimarySmall;

// src/components/LightChatSecondaryLarge.tsx
import * as React162 from "react";
function LightChatSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React162.createElement("img", {
    alt: "LightChatSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightChatSecondaryLarge.svg",
    width
  });
}
var LightChatSecondaryLarge_default = LightChatSecondaryLarge;

// src/components/LightChatPrimaryLarge.tsx
import * as React163 from "react";
function LightChatPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React163.createElement("img", {
    alt: "LightChatPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightChatPrimaryLarge.svg",
    width
  });
}
var LightChatPrimaryLarge_default = LightChatPrimaryLarge;

// src/components/LightAwardPrimarySmall.tsx
import * as React164 from "react";
function LightAwardPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React164.createElement("img", {
    alt: "LightAwardPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightAwardPrimarySmall.svg",
    width
  });
}
var LightAwardPrimarySmall_default = LightAwardPrimarySmall;

// src/components/LightBillingSecondarySmall.tsx
import * as React165 from "react";
function LightBillingSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React165.createElement("img", {
    alt: "LightBillingSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightBillingSecondarySmall.svg",
    width
  });
}
var LightBillingSecondarySmall_default = LightBillingSecondarySmall;

// src/components/LightArenaSecondaryLarge.tsx
import * as React166 from "react";
function LightArenaSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React166.createElement("img", {
    alt: "LightArenaSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightArenaSecondaryLarge.svg",
    width
  });
}
var LightArenaSecondaryLarge_default = LightArenaSecondaryLarge;

// src/components/LightAwardSecondaryLarge.tsx
import * as React167 from "react";
function LightAwardSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React167.createElement("img", {
    alt: "LightAwardSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightAwardSecondaryLarge.svg",
    width
  });
}
var LightAwardSecondaryLarge_default = LightAwardSecondaryLarge;

// src/components/LightCaptainPrimarySmall.tsx
import * as React168 from "react";
function LightCaptainPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React168.createElement("img", {
    alt: "LightCaptainPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCaptainPrimarySmall.svg",
    width
  });
}
var LightCaptainPrimarySmall_default = LightCaptainPrimarySmall;

// src/components/LightCharacterSelectPrimaryLarge.tsx
import * as React169 from "react";
function LightCharacterSelectPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React169.createElement("img", {
    alt: "LightCharacterSelectPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCharacterSelectPrimaryLarge.svg",
    width
  });
}
var LightCharacterSelectPrimaryLarge_default = LightCharacterSelectPrimaryLarge;

// src/components/LightCoachSecondarySmall.tsx
import * as React170 from "react";
function LightCoachSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React170.createElement("img", {
    alt: "LightCoachSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCoachSecondarySmall.svg",
    width
  });
}
var LightCoachSecondarySmall_default = LightCoachSecondarySmall;

// src/components/LightArenaPrimaryLarge.tsx
import * as React171 from "react";
function LightArenaPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React171.createElement("img", {
    alt: "LightArenaPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightArenaPrimaryLarge.svg",
    width
  });
}
var LightArenaPrimaryLarge_default = LightArenaPrimaryLarge;

// src/components/LightCaptainSecondaryLarge.tsx
import * as React172 from "react";
function LightCaptainSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React172.createElement("img", {
    alt: "LightCaptainSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightCaptainSecondaryLarge.svg",
    width
  });
}
var LightCaptainSecondaryLarge_default = LightCaptainSecondaryLarge;

// src/components/LightAwardSecondarySmall.tsx
import * as React173 from "react";
function LightAwardSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React173.createElement("img", {
    alt: "LightAwardSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightAwardSecondarySmall.svg",
    width
  });
}
var LightAwardSecondarySmall_default = LightAwardSecondarySmall;

// src/components/LightChatSecondarySmall.tsx
import * as React174 from "react";
function LightChatSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React174.createElement("img", {
    alt: "LightChatSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightChatSecondarySmall.svg",
    width
  });
}
var LightChatSecondarySmall_default = LightChatSecondarySmall;

// src/components/LightConstructionPrimaryLarge.tsx
import * as React175 from "react";
function LightConstructionPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React175.createElement("img", {
    alt: "LightConstructionPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConstructionPrimaryLarge.svg",
    width
  });
}
var LightConstructionPrimaryLarge_default = LightConstructionPrimaryLarge;

// src/components/LightConstructionSecondaryLarge.tsx
import * as React176 from "react";
function LightConstructionSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React176.createElement("img", {
    alt: "LightConstructionSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConstructionSecondaryLarge.svg",
    width
  });
}
var LightConstructionSecondaryLarge_default = LightConstructionSecondaryLarge;

// src/components/LightConstructionPrimarySmall.tsx
import * as React177 from "react";
function LightConstructionPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React177.createElement("img", {
    alt: "LightConstructionPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConstructionPrimarySmall.svg",
    width
  });
}
var LightConstructionPrimarySmall_default = LightConstructionPrimarySmall;

// src/components/LightConstructionSecondarySmall.tsx
import * as React178 from "react";
function LightConstructionSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React178.createElement("img", {
    alt: "LightConstructionSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConstructionSecondarySmall.svg",
    width
  });
}
var LightConstructionSecondarySmall_default = LightConstructionSecondarySmall;

// src/components/LightConstructionPrimaryMedium.tsx
import * as React179 from "react";
function LightConstructionPrimaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React179.createElement("img", {
    alt: "LightConstructionPrimaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConstructionPrimaryMedium.svg",
    width
  });
}
var LightConstructionPrimaryMedium_default = LightConstructionPrimaryMedium;

// src/components/LightConstructionSecondaryMedium.tsx
import * as React180 from "react";
function LightConstructionSecondaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React180.createElement("img", {
    alt: "LightConstructionSecondaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightConstructionSecondaryMedium.svg",
    width
  });
}
var LightConstructionSecondaryMedium_default = LightConstructionSecondaryMedium;

// src/components/DarkCheckboxSecondarySmall.tsx
import * as React181 from "react";
function DarkCheckboxSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React181.createElement("img", {
    alt: "DarkCheckboxSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCheckboxSecondarySmall.svg",
    width
  });
}
var DarkCheckboxSecondarySmall_default = DarkCheckboxSecondarySmall;

// src/components/DarkTrophySecondaryLarge.tsx
import * as React182 from "react";
function DarkTrophySecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React182.createElement("img", {
    alt: "DarkTrophySecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkTrophySecondaryLarge.svg",
    width
  });
}
var DarkTrophySecondaryLarge_default = DarkTrophySecondaryLarge;

// src/components/DarkVideoSecondarySmall.tsx
import * as React183 from "react";
function DarkVideoSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React183.createElement("img", {
    alt: "DarkVideoSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkVideoSecondarySmall.svg",
    width
  });
}
var DarkVideoSecondarySmall_default = DarkVideoSecondarySmall;

// src/components/DarkVideoPrimarySmall.tsx
import * as React184 from "react";
function DarkVideoPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React184.createElement("img", {
    alt: "DarkVideoPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkVideoPrimarySmall.svg",
    width
  });
}
var DarkVideoPrimarySmall_default = DarkVideoPrimarySmall;

// src/components/DarkVideoPrimaryLarge.tsx
import * as React185 from "react";
function DarkVideoPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React185.createElement("img", {
    alt: "DarkVideoPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkVideoPrimaryLarge.svg",
    width
  });
}
var DarkVideoPrimaryLarge_default = DarkVideoPrimaryLarge;

// src/components/DarkVerificationPrimarySmall.tsx
import * as React186 from "react";
function DarkVerificationPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React186.createElement("img", {
    alt: "DarkVerificationPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkVerificationPrimarySmall.svg",
    width
  });
}
var DarkVerificationPrimarySmall_default = DarkVerificationPrimarySmall;

// src/components/DarkVideoSecondaryLarge.tsx
import * as React187 from "react";
function DarkVideoSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React187.createElement("img", {
    alt: "DarkVideoSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkVideoSecondaryLarge.svg",
    width
  });
}
var DarkVideoSecondaryLarge_default = DarkVideoSecondaryLarge;

// src/components/DarkUploadDocPrimaryLarge.tsx
import * as React188 from "react";
function DarkUploadDocPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React188.createElement("img", {
    alt: "DarkUploadDocPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkUploadDocPrimaryLarge.svg",
    width
  });
}
var DarkUploadDocPrimaryLarge_default = DarkUploadDocPrimaryLarge;

// src/components/DarkVerificationSecondaryLarge.tsx
import * as React189 from "react";
function DarkVerificationSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React189.createElement("img", {
    alt: "DarkVerificationSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkVerificationSecondaryLarge.svg",
    width
  });
}
var DarkVerificationSecondaryLarge_default = DarkVerificationSecondaryLarge;

// src/components/DarkTrophySecondarySmall.tsx
import * as React190 from "react";
function DarkTrophySecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React190.createElement("img", {
    alt: "DarkTrophySecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkTrophySecondarySmall.svg",
    width
  });
}
var DarkTrophySecondarySmall_default = DarkTrophySecondarySmall;

// src/components/DarkTrophyPrimaryLarge.tsx
import * as React191 from "react";
function DarkTrophyPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React191.createElement("img", {
    alt: "DarkTrophyPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkTrophyPrimaryLarge.svg",
    width
  });
}
var DarkTrophyPrimaryLarge_default = DarkTrophyPrimaryLarge;

// src/components/DarkStrategyPrimaryLarge.tsx
import * as React192 from "react";
function DarkStrategyPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React192.createElement("img", {
    alt: "DarkStrategyPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStrategyPrimaryLarge.svg",
    width
  });
}
var DarkStrategyPrimaryLarge_default = DarkStrategyPrimaryLarge;

// src/components/DarkVerificationPrimaryLarge.tsx
import * as React193 from "react";
function DarkVerificationPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React193.createElement("img", {
    alt: "DarkVerificationPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkVerificationPrimaryLarge.svg",
    width
  });
}
var DarkVerificationPrimaryLarge_default = DarkVerificationPrimaryLarge;

// src/components/DarkTeamPlayerPrimaryLarge.tsx
import * as React194 from "react";
function DarkTeamPlayerPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React194.createElement("img", {
    alt: "DarkTeamPlayerPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkTeamPlayerPrimaryLarge.svg",
    width
  });
}
var DarkTeamPlayerPrimaryLarge_default = DarkTeamPlayerPrimaryLarge;

// src/components/DarkVerificationSecondarySmall.tsx
import * as React195 from "react";
function DarkVerificationSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React195.createElement("img", {
    alt: "DarkVerificationSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkVerificationSecondarySmall.svg",
    width
  });
}
var DarkVerificationSecondarySmall_default = DarkVerificationSecondarySmall;

// src/components/DarkTeamPlayerSecondaryLarge.tsx
import * as React196 from "react";
function DarkTeamPlayerSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React196.createElement("img", {
    alt: "DarkTeamPlayerSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkTeamPlayerSecondaryLarge.svg",
    width
  });
}
var DarkTeamPlayerSecondaryLarge_default = DarkTeamPlayerSecondaryLarge;

// src/components/DarkUploadDocSecondaryLarge.tsx
import * as React197 from "react";
function DarkUploadDocSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React197.createElement("img", {
    alt: "DarkUploadDocSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkUploadDocSecondaryLarge.svg",
    width
  });
}
var DarkUploadDocSecondaryLarge_default = DarkUploadDocSecondaryLarge;

// src/components/DarkStatsSecondarySmall.tsx
import * as React198 from "react";
function DarkStatsSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React198.createElement("img", {
    alt: "DarkStatsSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStatsSecondarySmall.svg",
    width
  });
}
var DarkStatsSecondarySmall_default = DarkStatsSecondarySmall;

// src/components/DarkStatsPrimaryLarge.tsx
import * as React199 from "react";
function DarkStatsPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React199.createElement("img", {
    alt: "DarkStatsPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStatsPrimaryLarge.svg",
    width
  });
}
var DarkStatsPrimaryLarge_default = DarkStatsPrimaryLarge;

// src/components/DarkTeamPlayerPrimarySmall.tsx
import * as React200 from "react";
function DarkTeamPlayerPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React200.createElement("img", {
    alt: "DarkTeamPlayerPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkTeamPlayerPrimarySmall.svg",
    width
  });
}
var DarkTeamPlayerPrimarySmall_default = DarkTeamPlayerPrimarySmall;

// src/components/DarkUploadDocPrimarySmall.tsx
import * as React201 from "react";
function DarkUploadDocPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React201.createElement("img", {
    alt: "DarkUploadDocPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkUploadDocPrimarySmall.svg",
    width
  });
}
var DarkUploadDocPrimarySmall_default = DarkUploadDocPrimarySmall;

// src/components/DarkTrophyPrimarySmall.tsx
import * as React202 from "react";
function DarkTrophyPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React202.createElement("img", {
    alt: "DarkTrophyPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkTrophyPrimarySmall.svg",
    width
  });
}
var DarkTrophyPrimarySmall_default = DarkTrophyPrimarySmall;

// src/components/DarkStrategySecondarySmall.tsx
import * as React203 from "react";
function DarkStrategySecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React203.createElement("img", {
    alt: "DarkStrategySecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStrategySecondarySmall.svg",
    width
  });
}
var DarkStrategySecondarySmall_default = DarkStrategySecondarySmall;

// src/components/DarkStadiumPrimaryLarge.tsx
import * as React204 from "react";
function DarkStadiumPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React204.createElement("img", {
    alt: "DarkStadiumPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStadiumPrimaryLarge.svg",
    width
  });
}
var DarkStadiumPrimaryLarge_default = DarkStadiumPrimaryLarge;

// src/components/DarkTeamPlayerSecondarySmall.tsx
import * as React205 from "react";
function DarkTeamPlayerSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React205.createElement("img", {
    alt: "DarkTeamPlayerSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkTeamPlayerSecondarySmall.svg",
    width
  });
}
var DarkTeamPlayerSecondarySmall_default = DarkTeamPlayerSecondarySmall;

// src/components/DarkStrategySecondaryLarge.tsx
import * as React206 from "react";
function DarkStrategySecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React206.createElement("img", {
    alt: "DarkStrategySecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStrategySecondaryLarge.svg",
    width
  });
}
var DarkStrategySecondaryLarge_default = DarkStrategySecondaryLarge;

// src/components/DarkSportsmanshipSecondaryLarge.tsx
import * as React207 from "react";
function DarkSportsmanshipSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React207.createElement("img", {
    alt: "DarkSportsmanshipSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkSportsmanshipSecondaryLarge.svg",
    width
  });
}
var DarkSportsmanshipSecondaryLarge_default = DarkSportsmanshipSecondaryLarge;

// src/components/DarkUploadDocSecondarySmall.tsx
import * as React208 from "react";
function DarkUploadDocSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React208.createElement("img", {
    alt: "DarkUploadDocSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkUploadDocSecondarySmall.svg",
    width
  });
}
var DarkUploadDocSecondarySmall_default = DarkUploadDocSecondarySmall;

// src/components/DarkScheduleSecondarySmall.tsx
import * as React209 from "react";
function DarkScheduleSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React209.createElement("img", {
    alt: "DarkScheduleSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkScheduleSecondarySmall.svg",
    width
  });
}
var DarkScheduleSecondarySmall_default = DarkScheduleSecondarySmall;

// src/components/DarkStatsSecondaryLarge.tsx
import * as React210 from "react";
function DarkStatsSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React210.createElement("img", {
    alt: "DarkStatsSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStatsSecondaryLarge.svg",
    width
  });
}
var DarkStatsSecondaryLarge_default = DarkStatsSecondaryLarge;

// src/components/DarkStrategyPrimarySmall.tsx
import * as React211 from "react";
function DarkStrategyPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React211.createElement("img", {
    alt: "DarkStrategyPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStrategyPrimarySmall.svg",
    width
  });
}
var DarkStrategyPrimarySmall_default = DarkStrategyPrimarySmall;

// src/components/DarkResourcesPrimarySmall.tsx
import * as React212 from "react";
function DarkResourcesPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React212.createElement("img", {
    alt: "DarkResourcesPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkResourcesPrimarySmall.svg",
    width
  });
}
var DarkResourcesPrimarySmall_default = DarkResourcesPrimarySmall;

// src/components/DarkStatsPrimarySmall.tsx
import * as React213 from "react";
function DarkStatsPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React213.createElement("img", {
    alt: "DarkStatsPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStatsPrimarySmall.svg",
    width
  });
}
var DarkStatsPrimarySmall_default = DarkStatsPrimarySmall;

// src/components/DarkPendingSecondarySmall.tsx
import * as React214 from "react";
function DarkPendingSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React214.createElement("img", {
    alt: "DarkPendingSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkPendingSecondarySmall.svg",
    width
  });
}
var DarkPendingSecondarySmall_default = DarkPendingSecondarySmall;

// src/components/DarkStandingSecondarySmall.tsx
import * as React215 from "react";
function DarkStandingSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React215.createElement("img", {
    alt: "DarkStandingSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStandingSecondarySmall.svg",
    width
  });
}
var DarkStandingSecondarySmall_default = DarkStandingSecondarySmall;

// src/components/DarkRewardSecondarySmall.tsx
import * as React216 from "react";
function DarkRewardSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React216.createElement("img", {
    alt: "DarkRewardSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkRewardSecondarySmall.svg",
    width
  });
}
var DarkRewardSecondarySmall_default = DarkRewardSecondarySmall;

// src/components/DarkStadiumPrimarySmall.tsx
import * as React217 from "react";
function DarkStadiumPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React217.createElement("img", {
    alt: "DarkStadiumPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStadiumPrimarySmall.svg",
    width
  });
}
var DarkStadiumPrimarySmall_default = DarkStadiumPrimarySmall;

// src/components/DarkStandingSecondaryLarge.tsx
import * as React218 from "react";
function DarkStandingSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React218.createElement("img", {
    alt: "DarkStandingSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStandingSecondaryLarge.svg",
    width
  });
}
var DarkStandingSecondaryLarge_default = DarkStandingSecondaryLarge;

// src/components/DarkStadiumSecondarySmall.tsx
import * as React219 from "react";
function DarkStadiumSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React219.createElement("img", {
    alt: "DarkStadiumSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStadiumSecondarySmall.svg",
    width
  });
}
var DarkStadiumSecondarySmall_default = DarkStadiumSecondarySmall;

// src/components/DarkStandingPrimarySmall.tsx
import * as React220 from "react";
function DarkStandingPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React220.createElement("img", {
    alt: "DarkStandingPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStandingPrimarySmall.svg",
    width
  });
}
var DarkStandingPrimarySmall_default = DarkStandingPrimarySmall;

// src/components/DarkRewardPrimaryLarge.tsx
import * as React221 from "react";
function DarkRewardPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React221.createElement("img", {
    alt: "DarkRewardPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkRewardPrimaryLarge.svg",
    width
  });
}
var DarkRewardPrimaryLarge_default = DarkRewardPrimaryLarge;

// src/components/DarkSchoolPrimarySmall.tsx
import * as React222 from "react";
function DarkSchoolPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React222.createElement("img", {
    alt: "DarkSchoolPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkSchoolPrimarySmall.svg",
    width
  });
}
var DarkSchoolPrimarySmall_default = DarkSchoolPrimarySmall;

// src/components/DarkStandingPrimaryLarge.tsx
import * as React223 from "react";
function DarkStandingPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React223.createElement("img", {
    alt: "DarkStandingPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStandingPrimaryLarge.svg",
    width
  });
}
var DarkStandingPrimaryLarge_default = DarkStandingPrimaryLarge;

// src/components/DarkSportsmanshipPrimarySmall.tsx
import * as React224 from "react";
function DarkSportsmanshipPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React224.createElement("img", {
    alt: "DarkSportsmanshipPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkSportsmanshipPrimarySmall.svg",
    width
  });
}
var DarkSportsmanshipPrimarySmall_default = DarkSportsmanshipPrimarySmall;

// src/components/DarkSportsmanshipSecondarySmall.tsx
import * as React225 from "react";
function DarkSportsmanshipSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React225.createElement("img", {
    alt: "DarkSportsmanshipSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkSportsmanshipSecondarySmall.svg",
    width
  });
}
var DarkSportsmanshipSecondarySmall_default = DarkSportsmanshipSecondarySmall;

// src/components/DarkPendingPrimaryLarge.tsx
import * as React226 from "react";
function DarkPendingPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React226.createElement("img", {
    alt: "DarkPendingPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkPendingPrimaryLarge.svg",
    width
  });
}
var DarkPendingPrimaryLarge_default = DarkPendingPrimaryLarge;

// src/components/DarkStadiumSecondaryLarge.tsx
import * as React227 from "react";
function DarkStadiumSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React227.createElement("img", {
    alt: "DarkStadiumSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkStadiumSecondaryLarge.svg",
    width
  });
}
var DarkStadiumSecondaryLarge_default = DarkStadiumSecondaryLarge;

// src/components/DarkSportsmanshipPrimaryLarge.tsx
import * as React228 from "react";
function DarkSportsmanshipPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React228.createElement("img", {
    alt: "DarkSportsmanshipPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkSportsmanshipPrimaryLarge.svg",
    width
  });
}
var DarkSportsmanshipPrimaryLarge_default = DarkSportsmanshipPrimaryLarge;

// src/components/DarkResourcesPrimaryLarge.tsx
import * as React229 from "react";
function DarkResourcesPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React229.createElement("img", {
    alt: "DarkResourcesPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkResourcesPrimaryLarge.svg",
    width
  });
}
var DarkResourcesPrimaryLarge_default = DarkResourcesPrimaryLarge;

// src/components/DarkSchoolSecondarySmall.tsx
import * as React230 from "react";
function DarkSchoolSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React230.createElement("img", {
    alt: "DarkSchoolSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkSchoolSecondarySmall.svg",
    width
  });
}
var DarkSchoolSecondarySmall_default = DarkSchoolSecondarySmall;

// src/components/DarkSchoolSecondaryLarge.tsx
import * as React231 from "react";
function DarkSchoolSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React231.createElement("img", {
    alt: "DarkSchoolSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkSchoolSecondaryLarge.svg",
    width
  });
}
var DarkSchoolSecondaryLarge_default = DarkSchoolSecondaryLarge;

// src/components/DarkSchedulePrimaryLarge.tsx
import * as React232 from "react";
function DarkSchedulePrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React232.createElement("img", {
    alt: "DarkSchedulePrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkSchedulePrimaryLarge.svg",
    width
  });
}
var DarkSchedulePrimaryLarge_default = DarkSchedulePrimaryLarge;

// src/components/DarkPassSecondarySmall.tsx
import * as React233 from "react";
function DarkPassSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React233.createElement("img", {
    alt: "DarkPassSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkPassSecondarySmall.svg",
    width
  });
}
var DarkPassSecondarySmall_default = DarkPassSecondarySmall;

// src/components/DarkSchoolPrimaryLarge.tsx
import * as React234 from "react";
function DarkSchoolPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React234.createElement("img", {
    alt: "DarkSchoolPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkSchoolPrimaryLarge.svg",
    width
  });
}
var DarkSchoolPrimaryLarge_default = DarkSchoolPrimaryLarge;

// src/components/DarkNotVerifiedPrimarySmall.tsx
import * as React235 from "react";
function DarkNotVerifiedPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React235.createElement("img", {
    alt: "DarkNotVerifiedPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkNotVerifiedPrimarySmall.svg",
    width
  });
}
var DarkNotVerifiedPrimarySmall_default = DarkNotVerifiedPrimarySmall;

// src/components/DarkResourcesSecondaryLarge.tsx
import * as React236 from "react";
function DarkResourcesSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React236.createElement("img", {
    alt: "DarkResourcesSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkResourcesSecondaryLarge.svg",
    width
  });
}
var DarkResourcesSecondaryLarge_default = DarkResourcesSecondaryLarge;

// src/components/DarkRewardSecondaryLarge.tsx
import * as React237 from "react";
function DarkRewardSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React237.createElement("img", {
    alt: "DarkRewardSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkRewardSecondaryLarge.svg",
    width
  });
}
var DarkRewardSecondaryLarge_default = DarkRewardSecondaryLarge;

// src/components/DarkRewardPrimarySmall.tsx
import * as React238 from "react";
function DarkRewardPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React238.createElement("img", {
    alt: "DarkRewardPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkRewardPrimarySmall.svg",
    width
  });
}
var DarkRewardPrimarySmall_default = DarkRewardPrimarySmall;

// src/components/DarkResourcesSecondarySmall.tsx
import * as React239 from "react";
function DarkResourcesSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React239.createElement("img", {
    alt: "DarkResourcesSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkResourcesSecondarySmall.svg",
    width
  });
}
var DarkResourcesSecondarySmall_default = DarkResourcesSecondarySmall;

// src/components/DarkResourcesSecondaryMedium.tsx
import * as React240 from "react";
function DarkResourcesSecondaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React240.createElement("img", {
    alt: "DarkResourcesSecondaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkResourcesSecondaryMedium.svg",
    width
  });
}
var DarkResourcesSecondaryMedium_default = DarkResourcesSecondaryMedium;

// src/components/DarkResourcesPrimaryMedium.tsx
import * as React241 from "react";
function DarkResourcesPrimaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React241.createElement("img", {
    alt: "DarkResourcesPrimaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkResourcesPrimaryMedium.svg",
    width
  });
}
var DarkResourcesPrimaryMedium_default = DarkResourcesPrimaryMedium;

// src/components/DarkSchedulePrimarySmall.tsx
import * as React242 from "react";
function DarkSchedulePrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React242.createElement("img", {
    alt: "DarkSchedulePrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkSchedulePrimarySmall.svg",
    width
  });
}
var DarkSchedulePrimarySmall_default = DarkSchedulePrimarySmall;

// src/components/DarkMouseSecondaryLarge.tsx
import * as React243 from "react";
function DarkMouseSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React243.createElement("img", {
    alt: "DarkMouseSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMouseSecondaryLarge.svg",
    width
  });
}
var DarkMouseSecondaryLarge_default = DarkMouseSecondaryLarge;

// src/components/DarkPassPrimaryLarge.tsx
import * as React244 from "react";
function DarkPassPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React244.createElement("img", {
    alt: "DarkPassPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkPassPrimaryLarge.svg",
    width
  });
}
var DarkPassPrimaryLarge_default = DarkPassPrimaryLarge;

// src/components/DarkScheduleSecondaryLarge.tsx
import * as React245 from "react";
function DarkScheduleSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React245.createElement("img", {
    alt: "DarkScheduleSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkScheduleSecondaryLarge.svg",
    width
  });
}
var DarkScheduleSecondaryLarge_default = DarkScheduleSecondaryLarge;

// src/components/DarkNotificationSecondarySmall.tsx
import * as React246 from "react";
function DarkNotificationSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React246.createElement("img", {
    alt: "DarkNotificationSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkNotificationSecondarySmall.svg",
    width
  });
}
var DarkNotificationSecondarySmall_default = DarkNotificationSecondarySmall;

// src/components/DarkMousePrimaryLarge.tsx
import * as React247 from "react";
function DarkMousePrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React247.createElement("img", {
    alt: "DarkMousePrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMousePrimaryLarge.svg",
    width
  });
}
var DarkMousePrimaryLarge_default = DarkMousePrimaryLarge;

// src/components/DarkNotificationPrimarySmall.tsx
import * as React248 from "react";
function DarkNotificationPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React248.createElement("img", {
    alt: "DarkNotificationPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkNotificationPrimarySmall.svg",
    width
  });
}
var DarkNotificationPrimarySmall_default = DarkNotificationPrimarySmall;

// src/components/DarkPendingPrimarySmall.tsx
import * as React249 from "react";
function DarkPendingPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React249.createElement("img", {
    alt: "DarkPendingPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkPendingPrimarySmall.svg",
    width
  });
}
var DarkPendingPrimarySmall_default = DarkPendingPrimarySmall;

// src/components/DarkMousePrimarySmall.tsx
import * as React250 from "react";
function DarkMousePrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React250.createElement("img", {
    alt: "DarkMousePrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMousePrimarySmall.svg",
    width
  });
}
var DarkMousePrimarySmall_default = DarkMousePrimarySmall;

// src/components/DarkLeagueSecondarySmall.tsx
import * as React251 from "react";
function DarkLeagueSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React251.createElement("img", {
    alt: "DarkLeagueSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkLeagueSecondarySmall.svg",
    width
  });
}
var DarkLeagueSecondarySmall_default = DarkLeagueSecondarySmall;

// src/components/DarkPassPrimarySmall.tsx
import * as React252 from "react";
function DarkPassPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React252.createElement("img", {
    alt: "DarkPassPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkPassPrimarySmall.svg",
    width
  });
}
var DarkPassPrimarySmall_default = DarkPassPrimarySmall;

// src/components/DarkPassSecondaryLarge.tsx
import * as React253 from "react";
function DarkPassSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React253.createElement("img", {
    alt: "DarkPassSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkPassSecondaryLarge.svg",
    width
  });
}
var DarkPassSecondaryLarge_default = DarkPassSecondaryLarge;

// src/components/DarkNotificationSecondaryLarge.tsx
import * as React254 from "react";
function DarkNotificationSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React254.createElement("img", {
    alt: "DarkNotificationSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkNotificationSecondaryLarge.svg",
    width
  });
}
var DarkNotificationSecondaryLarge_default = DarkNotificationSecondaryLarge;

// src/components/DarkMoneySecondaryMedium.tsx
import * as React255 from "react";
function DarkMoneySecondaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React255.createElement("img", {
    alt: "DarkMoneySecondaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMoneySecondaryMedium.svg",
    width
  });
}
var DarkMoneySecondaryMedium_default = DarkMoneySecondaryMedium;

// src/components/DarkNotVerifiedSecondarySmall.tsx
import * as React256 from "react";
function DarkNotVerifiedSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React256.createElement("img", {
    alt: "DarkNotVerifiedSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkNotVerifiedSecondarySmall.svg",
    width
  });
}
var DarkNotVerifiedSecondarySmall_default = DarkNotVerifiedSecondarySmall;

// src/components/DarkNotVerifiedSecondaryLarge.tsx
import * as React257 from "react";
function DarkNotVerifiedSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React257.createElement("img", {
    alt: "DarkNotVerifiedSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkNotVerifiedSecondaryLarge.svg",
    width
  });
}
var DarkNotVerifiedSecondaryLarge_default = DarkNotVerifiedSecondaryLarge;

// src/components/DarkNotVerifiedPrimaryLarge.tsx
import * as React258 from "react";
function DarkNotVerifiedPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React258.createElement("img", {
    alt: "DarkNotVerifiedPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkNotVerifiedPrimaryLarge.svg",
    width
  });
}
var DarkNotVerifiedPrimaryLarge_default = DarkNotVerifiedPrimaryLarge;

// src/components/DarkPendingSecondaryLarge.tsx
import * as React259 from "react";
function DarkPendingSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React259.createElement("img", {
    alt: "DarkPendingSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkPendingSecondaryLarge.svg",
    width
  });
}
var DarkPendingSecondaryLarge_default = DarkPendingSecondaryLarge;

// src/components/DarkMoneySecondarySmall.tsx
import * as React260 from "react";
function DarkMoneySecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React260.createElement("img", {
    alt: "DarkMoneySecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMoneySecondarySmall.svg",
    width
  });
}
var DarkMoneySecondarySmall_default = DarkMoneySecondarySmall;

// src/components/DarkLeaguePrimaryLarge.tsx
import * as React261 from "react";
function DarkLeaguePrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React261.createElement("img", {
    alt: "DarkLeaguePrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkLeaguePrimaryLarge.svg",
    width
  });
}
var DarkLeaguePrimaryLarge_default = DarkLeaguePrimaryLarge;

// src/components/DarkHighAlertPrimarySmall.tsx
import * as React262 from "react";
function DarkHighAlertPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React262.createElement("img", {
    alt: "DarkHighAlertPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkHighAlertPrimarySmall.svg",
    width
  });
}
var DarkHighAlertPrimarySmall_default = DarkHighAlertPrimarySmall;

// src/components/DarkMegaphonePrimarySmall.tsx
import * as React263 from "react";
function DarkMegaphonePrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React263.createElement("img", {
    alt: "DarkMegaphonePrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMegaphonePrimarySmall.svg",
    width
  });
}
var DarkMegaphonePrimarySmall_default = DarkMegaphonePrimarySmall;

// src/components/DarkMoneyPrimaryMedium.tsx
import * as React264 from "react";
function DarkMoneyPrimaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React264.createElement("img", {
    alt: "DarkMoneyPrimaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMoneyPrimaryMedium.svg",
    width
  });
}
var DarkMoneyPrimaryMedium_default = DarkMoneyPrimaryMedium;

// src/components/DarkNotificationPrimaryLarge.tsx
import * as React265 from "react";
function DarkNotificationPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React265.createElement("img", {
    alt: "DarkNotificationPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkNotificationPrimaryLarge.svg",
    width
  });
}
var DarkNotificationPrimaryLarge_default = DarkNotificationPrimaryLarge;

// src/components/DarkMegaphonePrimaryLarge.tsx
import * as React266 from "react";
function DarkMegaphonePrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React266.createElement("img", {
    alt: "DarkMegaphonePrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMegaphonePrimaryLarge.svg",
    width
  });
}
var DarkMegaphonePrimaryLarge_default = DarkMegaphonePrimaryLarge;

// src/components/DarkMouseSecondarySmall.tsx
import * as React267 from "react";
function DarkMouseSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React267.createElement("img", {
    alt: "DarkMouseSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMouseSecondarySmall.svg",
    width
  });
}
var DarkMouseSecondarySmall_default = DarkMouseSecondarySmall;

// src/components/DarkMegaphoneSecondaryLarge.tsx
import * as React268 from "react";
function DarkMegaphoneSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React268.createElement("img", {
    alt: "DarkMegaphoneSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMegaphoneSecondaryLarge.svg",
    width
  });
}
var DarkMegaphoneSecondaryLarge_default = DarkMegaphoneSecondaryLarge;

// src/components/DarkMoneyPrimarySmall.tsx
import * as React269 from "react";
function DarkMoneyPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React269.createElement("img", {
    alt: "DarkMoneyPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMoneyPrimarySmall.svg",
    width
  });
}
var DarkMoneyPrimarySmall_default = DarkMoneyPrimarySmall;

// src/components/DarkMoneySecondaryLarge.tsx
import * as React270 from "react";
function DarkMoneySecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React270.createElement("img", {
    alt: "DarkMoneySecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMoneySecondaryLarge.svg",
    width
  });
}
var DarkMoneySecondaryLarge_default = DarkMoneySecondaryLarge;

// src/components/DarkKeyboardSecondaryLarge.tsx
import * as React271 from "react";
function DarkKeyboardSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React271.createElement("img", {
    alt: "DarkKeyboardSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkKeyboardSecondaryLarge.svg",
    width
  });
}
var DarkKeyboardSecondaryLarge_default = DarkKeyboardSecondaryLarge;

// src/components/DarkLeaguePrimarySmall.tsx
import * as React272 from "react";
function DarkLeaguePrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React272.createElement("img", {
    alt: "DarkLeaguePrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkLeaguePrimarySmall.svg",
    width
  });
}
var DarkLeaguePrimarySmall_default = DarkLeaguePrimarySmall;

// src/components/DarkMoneyPrimaryLarge.tsx
import * as React273 from "react";
function DarkMoneyPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React273.createElement("img", {
    alt: "DarkMoneyPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMoneyPrimaryLarge.svg",
    width
  });
}
var DarkMoneyPrimaryLarge_default = DarkMoneyPrimaryLarge;

// src/components/DarkInvitePlayersSecondaryLarge.tsx
import * as React274 from "react";
function DarkInvitePlayersSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React274.createElement("img", {
    alt: "DarkInvitePlayersSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkInvitePlayersSecondaryLarge.svg",
    width
  });
}
var DarkInvitePlayersSecondaryLarge_default = DarkInvitePlayersSecondaryLarge;

// src/components/DarkConnectionSecondaryLarge.tsx
import * as React275 from "react";
function DarkConnectionSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React275.createElement("img", {
    alt: "DarkConnectionSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConnectionSecondaryLarge.svg",
    width
  });
}
var DarkConnectionSecondaryLarge_default = DarkConnectionSecondaryLarge;

// src/components/DarkLeagueSecondaryLarge.tsx
import * as React276 from "react";
function DarkLeagueSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React276.createElement("img", {
    alt: "DarkLeagueSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkLeagueSecondaryLarge.svg",
    width
  });
}
var DarkLeagueSecondaryLarge_default = DarkLeagueSecondaryLarge;

// src/components/DarkKeyboardPrimarySmall.tsx
import * as React277 from "react";
function DarkKeyboardPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React277.createElement("img", {
    alt: "DarkKeyboardPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkKeyboardPrimarySmall.svg",
    width
  });
}
var DarkKeyboardPrimarySmall_default = DarkKeyboardPrimarySmall;

// src/components/DarkMegaphoneSecondarySmall.tsx
import * as React278 from "react";
function DarkMegaphoneSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React278.createElement("img", {
    alt: "DarkMegaphoneSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkMegaphoneSecondarySmall.svg",
    width
  });
}
var DarkMegaphoneSecondarySmall_default = DarkMegaphoneSecondarySmall;

// src/components/DarkInvitePlayersSecondarySmall.tsx
import * as React279 from "react";
function DarkInvitePlayersSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React279.createElement("img", {
    alt: "DarkInvitePlayersSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkInvitePlayersSecondarySmall.svg",
    width
  });
}
var DarkInvitePlayersSecondarySmall_default = DarkInvitePlayersSecondarySmall;

// src/components/DarkFoamFingerSecondaryLarge.tsx
import * as React280 from "react";
function DarkFoamFingerSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React280.createElement("img", {
    alt: "DarkFoamFingerSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkFoamFingerSecondaryLarge.svg",
    width
  });
}
var DarkFoamFingerSecondaryLarge_default = DarkFoamFingerSecondaryLarge;

// src/components/DarkKeyboardPrimaryLarge.tsx
import * as React281 from "react";
function DarkKeyboardPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React281.createElement("img", {
    alt: "DarkKeyboardPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkKeyboardPrimaryLarge.svg",
    width
  });
}
var DarkKeyboardPrimaryLarge_default = DarkKeyboardPrimaryLarge;

// src/components/DarkFoamFingerPrimarySmall.tsx
import * as React282 from "react";
function DarkFoamFingerPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React282.createElement("img", {
    alt: "DarkFoamFingerPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkFoamFingerPrimarySmall.svg",
    width
  });
}
var DarkFoamFingerPrimarySmall_default = DarkFoamFingerPrimarySmall;

// src/components/DarkHighAlertSecondarySmall.tsx
import * as React283 from "react";
function DarkHighAlertSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React283.createElement("img", {
    alt: "DarkHighAlertSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkHighAlertSecondarySmall.svg",
    width
  });
}
var DarkHighAlertSecondarySmall_default = DarkHighAlertSecondarySmall;

// src/components/DarkGraduationHatSecondarySmall.tsx
import * as React284 from "react";
function DarkGraduationHatSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React284.createElement("img", {
    alt: "DarkGraduationHatSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkGraduationHatSecondarySmall.svg",
    width
  });
}
var DarkGraduationHatSecondarySmall_default = DarkGraduationHatSecondarySmall;

// src/components/DarkHighAlertPrimaryLarge.tsx
import * as React285 from "react";
function DarkHighAlertPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React285.createElement("img", {
    alt: "DarkHighAlertPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkHighAlertPrimaryLarge.svg",
    width
  });
}
var DarkHighAlertPrimaryLarge_default = DarkHighAlertPrimaryLarge;

// src/components/DarkGraduationHatSecondaryLarge.tsx
import * as React286 from "react";
function DarkGraduationHatSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React286.createElement("img", {
    alt: "DarkGraduationHatSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkGraduationHatSecondaryLarge.svg",
    width
  });
}
var DarkGraduationHatSecondaryLarge_default = DarkGraduationHatSecondaryLarge;

// src/components/DarkConnectionPrimaryLarge.tsx
import * as React287 from "react";
function DarkConnectionPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React287.createElement("img", {
    alt: "DarkConnectionPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConnectionPrimaryLarge.svg",
    width
  });
}
var DarkConnectionPrimaryLarge_default = DarkConnectionPrimaryLarge;

// src/components/DarkHighAlertSecondaryLarge.tsx
import * as React288 from "react";
function DarkHighAlertSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React288.createElement("img", {
    alt: "DarkHighAlertSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkHighAlertSecondaryLarge.svg",
    width
  });
}
var DarkHighAlertSecondaryLarge_default = DarkHighAlertSecondaryLarge;

// src/components/DarkKeyboardSecondarySmall.tsx
import * as React289 from "react";
function DarkKeyboardSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React289.createElement("img", {
    alt: "DarkKeyboardSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkKeyboardSecondarySmall.svg",
    width
  });
}
var DarkKeyboardSecondarySmall_default = DarkKeyboardSecondarySmall;

// src/components/DarkInvitePlayersPrimarySmall.tsx
import * as React290 from "react";
function DarkInvitePlayersPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React290.createElement("img", {
    alt: "DarkInvitePlayersPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkInvitePlayersPrimarySmall.svg",
    width
  });
}
var DarkInvitePlayersPrimarySmall_default = DarkInvitePlayersPrimarySmall;

// src/components/DarkCreateTeamPrimarySmall.tsx
import * as React291 from "react";
function DarkCreateTeamPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React291.createElement("img", {
    alt: "DarkCreateTeamPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCreateTeamPrimarySmall.svg",
    width
  });
}
var DarkCreateTeamPrimarySmall_default = DarkCreateTeamPrimarySmall;

// src/components/DarkGraduationHatPrimarySmall.tsx
import * as React292 from "react";
function DarkGraduationHatPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React292.createElement("img", {
    alt: "DarkGraduationHatPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkGraduationHatPrimarySmall.svg",
    width
  });
}
var DarkGraduationHatPrimarySmall_default = DarkGraduationHatPrimarySmall;

// src/components/DarkGraduationHatPrimaryLarge.tsx
import * as React293 from "react";
function DarkGraduationHatPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React293.createElement("img", {
    alt: "DarkGraduationHatPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkGraduationHatPrimaryLarge.svg",
    width
  });
}
var DarkGraduationHatPrimaryLarge_default = DarkGraduationHatPrimaryLarge;

// src/components/DarkEnrollmentSecondaryLarge.tsx
import * as React294 from "react";
function DarkEnrollmentSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React294.createElement("img", {
    alt: "DarkEnrollmentSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkEnrollmentSecondaryLarge.svg",
    width
  });
}
var DarkEnrollmentSecondaryLarge_default = DarkEnrollmentSecondaryLarge;

// src/components/DarkCreateTeamSecondaryLarge.tsx
import * as React295 from "react";
function DarkCreateTeamSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React295.createElement("img", {
    alt: "DarkCreateTeamSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCreateTeamSecondaryLarge.svg",
    width
  });
}
var DarkCreateTeamSecondaryLarge_default = DarkCreateTeamSecondaryLarge;

// src/components/DarkInvitePlayersPrimaryLarge.tsx
import * as React296 from "react";
function DarkInvitePlayersPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React296.createElement("img", {
    alt: "DarkInvitePlayersPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkInvitePlayersPrimaryLarge.svg",
    width
  });
}
var DarkInvitePlayersPrimaryLarge_default = DarkInvitePlayersPrimaryLarge;

// src/components/DarkFoamFingerPrimaryLarge.tsx
import * as React297 from "react";
function DarkFoamFingerPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React297.createElement("img", {
    alt: "DarkFoamFingerPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkFoamFingerPrimaryLarge.svg",
    width
  });
}
var DarkFoamFingerPrimaryLarge_default = DarkFoamFingerPrimaryLarge;

// src/components/DarkChatPrimarySmall.tsx
import * as React298 from "react";
function DarkChatPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React298.createElement("img", {
    alt: "DarkChatPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkChatPrimarySmall.svg",
    width
  });
}
var DarkChatPrimarySmall_default = DarkChatPrimarySmall;

// src/components/DarkEmailVerificationPrimaryLarge.tsx
import * as React299 from "react";
function DarkEmailVerificationPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React299.createElement("img", {
    alt: "DarkEmailVerificationPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkEmailVerificationPrimaryLarge.svg",
    width
  });
}
var DarkEmailVerificationPrimaryLarge_default = DarkEmailVerificationPrimaryLarge;

// src/components/DarkFlagsDarkSecondaryLarge.tsx
import * as React300 from "react";
function DarkFlagsDarkSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React300.createElement("img", {
    alt: "DarkFlagsDarkSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkFlagsDarkSecondaryLarge.svg",
    width
  });
}
var DarkFlagsDarkSecondaryLarge_default = DarkFlagsDarkSecondaryLarge;

// src/components/DarkFlagsDarkPrimaryLarge.tsx
import * as React301 from "react";
function DarkFlagsDarkPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React301.createElement("img", {
    alt: "DarkFlagsDarkPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkFlagsDarkPrimaryLarge.svg",
    width
  });
}
var DarkFlagsDarkPrimaryLarge_default = DarkFlagsDarkPrimaryLarge;

// src/components/DarkCreateTeamSecondarySmall.tsx
import * as React302 from "react";
function DarkCreateTeamSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React302.createElement("img", {
    alt: "DarkCreateTeamSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCreateTeamSecondarySmall.svg",
    width
  });
}
var DarkCreateTeamSecondarySmall_default = DarkCreateTeamSecondarySmall;

// src/components/DarkEnrollmentSecondarySmall.tsx
import * as React303 from "react";
function DarkEnrollmentSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React303.createElement("img", {
    alt: "DarkEnrollmentSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkEnrollmentSecondarySmall.svg",
    width
  });
}
var DarkEnrollmentSecondarySmall_default = DarkEnrollmentSecondarySmall;

// src/components/DarkCharacterSelectPrimarySmall.tsx
import * as React304 from "react";
function DarkCharacterSelectPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React304.createElement("img", {
    alt: "DarkCharacterSelectPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCharacterSelectPrimarySmall.svg",
    width
  });
}
var DarkCharacterSelectPrimarySmall_default = DarkCharacterSelectPrimarySmall;

// src/components/DarkCreateTeamPrimaryLarge.tsx
import * as React305 from "react";
function DarkCreateTeamPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React305.createElement("img", {
    alt: "DarkCreateTeamPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCreateTeamPrimaryLarge.svg",
    width
  });
}
var DarkCreateTeamPrimaryLarge_default = DarkCreateTeamPrimaryLarge;

// src/components/DarkErrorStateLarge.tsx
import * as React306 from "react";
function DarkErrorStateLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React306.createElement("img", {
    alt: "DarkErrorStateLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkErrorStateLarge.svg",
    width
  });
}
var DarkErrorStateLarge_default = DarkErrorStateLarge;

// src/components/DarkFlagsDarkPrimarySmall.tsx
import * as React307 from "react";
function DarkFlagsDarkPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React307.createElement("img", {
    alt: "DarkFlagsDarkPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkFlagsDarkPrimarySmall.svg",
    width
  });
}
var DarkFlagsDarkPrimarySmall_default = DarkFlagsDarkPrimarySmall;

// src/components/DarkEmailVerificationSecondaryLarge.tsx
import * as React308 from "react";
function DarkEmailVerificationSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React308.createElement("img", {
    alt: "DarkEmailVerificationSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkEmailVerificationSecondaryLarge.svg",
    width
  });
}
var DarkEmailVerificationSecondaryLarge_default = DarkEmailVerificationSecondaryLarge;

// src/components/DarkFoamFingerSecondarySmall.tsx
import * as React309 from "react";
function DarkFoamFingerSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React309.createElement("img", {
    alt: "DarkFoamFingerSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkFoamFingerSecondarySmall.svg",
    width
  });
}
var DarkFoamFingerSecondarySmall_default = DarkFoamFingerSecondarySmall;

// src/components/DarkEmailVerificationSecondarySmall.tsx
import * as React310 from "react";
function DarkEmailVerificationSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React310.createElement("img", {
    alt: "DarkEmailVerificationSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkEmailVerificationSecondarySmall.svg",
    width
  });
}
var DarkEmailVerificationSecondarySmall_default = DarkEmailVerificationSecondarySmall;

// src/components/DarkCrownSecondaryLarge.tsx
import * as React311 from "react";
function DarkCrownSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React311.createElement("img", {
    alt: "DarkCrownSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCrownSecondaryLarge.svg",
    width
  });
}
var DarkCrownSecondaryLarge_default = DarkCrownSecondaryLarge;

// src/components/DarkCourseSecondarySmall.tsx
import * as React312 from "react";
function DarkCourseSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React312.createElement("img", {
    alt: "DarkCourseSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCourseSecondarySmall.svg",
    width
  });
}
var DarkCourseSecondarySmall_default = DarkCourseSecondarySmall;

// src/components/DarkEnrollmentPrimaryLarge.tsx
import * as React313 from "react";
function DarkEnrollmentPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React313.createElement("img", {
    alt: "DarkEnrollmentPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkEnrollmentPrimaryLarge.svg",
    width
  });
}
var DarkEnrollmentPrimaryLarge_default = DarkEnrollmentPrimaryLarge;

// src/components/DarkCoursePrimarySmall.tsx
import * as React314 from "react";
function DarkCoursePrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React314.createElement("img", {
    alt: "DarkCoursePrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCoursePrimarySmall.svg",
    width
  });
}
var DarkCoursePrimarySmall_default = DarkCoursePrimarySmall;

// src/components/DarkCrownSecondarySmall.tsx
import * as React315 from "react";
function DarkCrownSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React315.createElement("img", {
    alt: "DarkCrownSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCrownSecondarySmall.svg",
    width
  });
}
var DarkCrownSecondarySmall_default = DarkCrownSecondarySmall;

// src/components/DarkCourseSecondaryLarge.tsx
import * as React316 from "react";
function DarkCourseSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React316.createElement("img", {
    alt: "DarkCourseSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCourseSecondaryLarge.svg",
    width
  });
}
var DarkCourseSecondaryLarge_default = DarkCourseSecondaryLarge;

// src/components/DarkConnectedAccountsSecondarySmall.tsx
import * as React317 from "react";
function DarkConnectedAccountsSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React317.createElement("img", {
    alt: "DarkConnectedAccountsSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConnectedAccountsSecondarySmall.svg",
    width
  });
}
var DarkConnectedAccountsSecondarySmall_default = DarkConnectedAccountsSecondarySmall;

// src/components/DarkCrownPrimaryLarge.tsx
import * as React318 from "react";
function DarkCrownPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React318.createElement("img", {
    alt: "DarkCrownPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCrownPrimaryLarge.svg",
    width
  });
}
var DarkCrownPrimaryLarge_default = DarkCrownPrimaryLarge;

// src/components/DarkConnectedAccountsPrimarySmall.tsx
import * as React319 from "react";
function DarkConnectedAccountsPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React319.createElement("img", {
    alt: "DarkConnectedAccountsPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConnectedAccountsPrimarySmall.svg",
    width
  });
}
var DarkConnectedAccountsPrimarySmall_default = DarkConnectedAccountsPrimarySmall;

// src/components/DarkConnectedAccountsPrimaryLarge.tsx
import * as React320 from "react";
function DarkConnectedAccountsPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React320.createElement("img", {
    alt: "DarkConnectedAccountsPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConnectedAccountsPrimaryLarge.svg",
    width
  });
}
var DarkConnectedAccountsPrimaryLarge_default = DarkConnectedAccountsPrimaryLarge;

// src/components/DarkEnrollmentPrimarySmall.tsx
import * as React321 from "react";
function DarkEnrollmentPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React321.createElement("img", {
    alt: "DarkEnrollmentPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkEnrollmentPrimarySmall.svg",
    width
  });
}
var DarkEnrollmentPrimarySmall_default = DarkEnrollmentPrimarySmall;

// src/components/DarkConnectedAccountsSecondaryLarge.tsx
import * as React322 from "react";
function DarkConnectedAccountsSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React322.createElement("img", {
    alt: "DarkConnectedAccountsSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConnectedAccountsSecondaryLarge.svg",
    width
  });
}
var DarkConnectedAccountsSecondaryLarge_default = DarkConnectedAccountsSecondaryLarge;

// src/components/DarkConnectionPrimarySmall.tsx
import * as React323 from "react";
function DarkConnectionPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React323.createElement("img", {
    alt: "DarkConnectionPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConnectionPrimarySmall.svg",
    width
  });
}
var DarkConnectionPrimarySmall_default = DarkConnectionPrimarySmall;

// src/components/DarkEmailVerificationPrimarySmall.tsx
import * as React324 from "react";
function DarkEmailVerificationPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React324.createElement("img", {
    alt: "DarkEmailVerificationPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkEmailVerificationPrimarySmall.svg",
    width
  });
}
var DarkEmailVerificationPrimarySmall_default = DarkEmailVerificationPrimarySmall;

// src/components/DarkAwardPrimaryLarge.tsx
import * as React325 from "react";
function DarkAwardPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React325.createElement("img", {
    alt: "DarkAwardPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkAwardPrimaryLarge.svg",
    width
  });
}
var DarkAwardPrimaryLarge_default = DarkAwardPrimaryLarge;

// src/components/DarkCrownPrimarySmall.tsx
import * as React326 from "react";
function DarkCrownPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React326.createElement("img", {
    alt: "DarkCrownPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCrownPrimarySmall.svg",
    width
  });
}
var DarkCrownPrimarySmall_default = DarkCrownPrimarySmall;

// src/components/DarkCoursePrimaryLarge.tsx
import * as React327 from "react";
function DarkCoursePrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React327.createElement("img", {
    alt: "DarkCoursePrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCoursePrimaryLarge.svg",
    width
  });
}
var DarkCoursePrimaryLarge_default = DarkCoursePrimaryLarge;

// src/components/DarkConnectionSecondarySmall.tsx
import * as React328 from "react";
function DarkConnectionSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React328.createElement("img", {
    alt: "DarkConnectionSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConnectionSecondarySmall.svg",
    width
  });
}
var DarkConnectionSecondarySmall_default = DarkConnectionSecondarySmall;

// src/components/DarkCheckboxSecondaryLarge.tsx
import * as React329 from "react";
function DarkCheckboxSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React329.createElement("img", {
    alt: "DarkCheckboxSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCheckboxSecondaryLarge.svg",
    width
  });
}
var DarkCheckboxSecondaryLarge_default = DarkCheckboxSecondaryLarge;

// src/components/DarkAwardPrimarySmall.tsx
import * as React330 from "react";
function DarkAwardPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React330.createElement("img", {
    alt: "DarkAwardPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkAwardPrimarySmall.svg",
    width
  });
}
var DarkAwardPrimarySmall_default = DarkAwardPrimarySmall;

// src/components/DarkCaptainSecondaryLarge.tsx
import * as React331 from "react";
function DarkCaptainSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React331.createElement("img", {
    alt: "DarkCaptainSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCaptainSecondaryLarge.svg",
    width
  });
}
var DarkCaptainSecondaryLarge_default = DarkCaptainSecondaryLarge;

// src/components/DarkAwardSecondaryLarge.tsx
import * as React332 from "react";
function DarkAwardSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React332.createElement("img", {
    alt: "DarkAwardSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkAwardSecondaryLarge.svg",
    width
  });
}
var DarkAwardSecondaryLarge_default = DarkAwardSecondaryLarge;

// src/components/DarkArenaSecondarySmall.tsx
import * as React333 from "react";
function DarkArenaSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React333.createElement("img", {
    alt: "DarkArenaSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkArenaSecondarySmall.svg",
    width
  });
}
var DarkArenaSecondarySmall_default = DarkArenaSecondarySmall;

// src/components/DarkCoachSecondarySmall.tsx
import * as React334 from "react";
function DarkCoachSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React334.createElement("img", {
    alt: "DarkCoachSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCoachSecondarySmall.svg",
    width
  });
}
var DarkCoachSecondarySmall_default = DarkCoachSecondarySmall;

// src/components/DarkCharacterSelectSecondaryLarge.tsx
import * as React335 from "react";
function DarkCharacterSelectSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React335.createElement("img", {
    alt: "DarkCharacterSelectSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCharacterSelectSecondaryLarge.svg",
    width
  });
}
var DarkCharacterSelectSecondaryLarge_default = DarkCharacterSelectSecondaryLarge;

// src/components/DarkBillingSecondaryLarge.tsx
import * as React336 from "react";
function DarkBillingSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React336.createElement("img", {
    alt: "DarkBillingSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkBillingSecondaryLarge.svg",
    width
  });
}
var DarkBillingSecondaryLarge_default = DarkBillingSecondaryLarge;

// src/components/DarkArenaPrimarySmall.tsx
import * as React337 from "react";
function DarkArenaPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React337.createElement("img", {
    alt: "DarkArenaPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkArenaPrimarySmall.svg",
    width
  });
}
var DarkArenaPrimarySmall_default = DarkArenaPrimarySmall;

// src/components/DarkCaptainPrimaryLarge.tsx
import * as React338 from "react";
function DarkCaptainPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React338.createElement("img", {
    alt: "DarkCaptainPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCaptainPrimaryLarge.svg",
    width
  });
}
var DarkCaptainPrimaryLarge_default = DarkCaptainPrimaryLarge;

// src/components/DarkAwardSecondarySmall.tsx
import * as React339 from "react";
function DarkAwardSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React339.createElement("img", {
    alt: "DarkAwardSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkAwardSecondarySmall.svg",
    width
  });
}
var DarkAwardSecondarySmall_default = DarkAwardSecondarySmall;

// src/components/DarkArenaSecondaryLarge.tsx
import * as React340 from "react";
function DarkArenaSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React340.createElement("img", {
    alt: "DarkArenaSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkArenaSecondaryLarge.svg",
    width
  });
}
var DarkArenaSecondaryLarge_default = DarkArenaSecondaryLarge;

// src/components/DarkCharacterSelectSecondarySmall.tsx
import * as React341 from "react";
function DarkCharacterSelectSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React341.createElement("img", {
    alt: "DarkCharacterSelectSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCharacterSelectSecondarySmall.svg",
    width
  });
}
var DarkCharacterSelectSecondarySmall_default = DarkCharacterSelectSecondarySmall;

// src/components/DarkCharacterSelectPrimaryLarge.tsx
import * as React342 from "react";
function DarkCharacterSelectPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React342.createElement("img", {
    alt: "DarkCharacterSelectPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCharacterSelectPrimaryLarge.svg",
    width
  });
}
var DarkCharacterSelectPrimaryLarge_default = DarkCharacterSelectPrimaryLarge;

// src/components/DarkCoachPrimarySmall.tsx
import * as React343 from "react";
function DarkCoachPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React343.createElement("img", {
    alt: "DarkCoachPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCoachPrimarySmall.svg",
    width
  });
}
var DarkCoachPrimarySmall_default = DarkCoachPrimarySmall;

// src/components/DarkCoachSecondaryLarge.tsx
import * as React344 from "react";
function DarkCoachSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React344.createElement("img", {
    alt: "DarkCoachSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCoachSecondaryLarge.svg",
    width
  });
}
var DarkCoachSecondaryLarge_default = DarkCoachSecondaryLarge;

// src/components/DarkCheckboxPrimarySmall.tsx
import * as React345 from "react";
function DarkCheckboxPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React345.createElement("img", {
    alt: "DarkCheckboxPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCheckboxPrimarySmall.svg",
    width
  });
}
var DarkCheckboxPrimarySmall_default = DarkCheckboxPrimarySmall;

// src/components/DarkChatPrimaryLarge.tsx
import * as React346 from "react";
function DarkChatPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React346.createElement("img", {
    alt: "DarkChatPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkChatPrimaryLarge.svg",
    width
  });
}
var DarkChatPrimaryLarge_default = DarkChatPrimaryLarge;

// src/components/DarkCoachPrimaryLarge.tsx
import * as React347 from "react";
function DarkCoachPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React347.createElement("img", {
    alt: "DarkCoachPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCoachPrimaryLarge.svg",
    width
  });
}
var DarkCoachPrimaryLarge_default = DarkCoachPrimaryLarge;

// src/components/DarkBillingPrimaryLarge.tsx
import * as React348 from "react";
function DarkBillingPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React348.createElement("img", {
    alt: "DarkBillingPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkBillingPrimaryLarge.svg",
    width
  });
}
var DarkBillingPrimaryLarge_default = DarkBillingPrimaryLarge;

// src/components/DarkCaptainPrimarySmall.tsx
import * as React349 from "react";
function DarkCaptainPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React349.createElement("img", {
    alt: "DarkCaptainPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCaptainPrimarySmall.svg",
    width
  });
}
var DarkCaptainPrimarySmall_default = DarkCaptainPrimarySmall;

// src/components/DarkCheckboxPrimaryLarge.tsx
import * as React350 from "react";
function DarkCheckboxPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React350.createElement("img", {
    alt: "DarkCheckboxPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCheckboxPrimaryLarge.svg",
    width
  });
}
var DarkCheckboxPrimaryLarge_default = DarkCheckboxPrimaryLarge;

// src/components/DarkBillingPrimarySmall.tsx
import * as React351 from "react";
function DarkBillingPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React351.createElement("img", {
    alt: "DarkBillingPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkBillingPrimarySmall.svg",
    width
  });
}
var DarkBillingPrimarySmall_default = DarkBillingPrimarySmall;

// src/components/DarkArenaPrimaryLarge.tsx
import * as React352 from "react";
function DarkArenaPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React352.createElement("img", {
    alt: "DarkArenaPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkArenaPrimaryLarge.svg",
    width
  });
}
var DarkArenaPrimaryLarge_default = DarkArenaPrimaryLarge;

// src/components/DarkChatSecondaryLarge.tsx
import * as React353 from "react";
function DarkChatSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React353.createElement("img", {
    alt: "DarkChatSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkChatSecondaryLarge.svg",
    width
  });
}
var DarkChatSecondaryLarge_default = DarkChatSecondaryLarge;

// src/components/DarkBillingSecondarySmall.tsx
import * as React354 from "react";
function DarkBillingSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React354.createElement("img", {
    alt: "DarkBillingSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkBillingSecondarySmall.svg",
    width
  });
}
var DarkBillingSecondarySmall_default = DarkBillingSecondarySmall;

// src/components/DarkCaptainSecondarySmall.tsx
import * as React355 from "react";
function DarkCaptainSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React355.createElement("img", {
    alt: "DarkCaptainSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkCaptainSecondarySmall.svg",
    width
  });
}
var DarkCaptainSecondarySmall_default = DarkCaptainSecondarySmall;

// src/components/DarkChatSecondarySmall.tsx
import * as React356 from "react";
function DarkChatSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React356.createElement("img", {
    alt: "DarkChatSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkChatSecondarySmall.svg",
    width
  });
}
var DarkChatSecondarySmall_default = DarkChatSecondarySmall;

// src/components/DarkConstructionPrimaryLarge.tsx
import * as React357 from "react";
function DarkConstructionPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React357.createElement("img", {
    alt: "DarkConstructionPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConstructionPrimaryLarge.svg",
    width
  });
}
var DarkConstructionPrimaryLarge_default = DarkConstructionPrimaryLarge;

// src/components/DarkConstructionPrimarySmall.tsx
import * as React358 from "react";
function DarkConstructionPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React358.createElement("img", {
    alt: "DarkConstructionPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConstructionPrimarySmall.svg",
    width
  });
}
var DarkConstructionPrimarySmall_default = DarkConstructionPrimarySmall;

// src/components/DarkConstructionSecondaryLarge.tsx
import * as React359 from "react";
function DarkConstructionSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React359.createElement("img", {
    alt: "DarkConstructionSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConstructionSecondaryLarge.svg",
    width
  });
}
var DarkConstructionSecondaryLarge_default = DarkConstructionSecondaryLarge;

// src/components/DarkConstructionSecondarySmall.tsx
import * as React360 from "react";
function DarkConstructionSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React360.createElement("img", {
    alt: "DarkConstructionSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConstructionSecondarySmall.svg",
    width
  });
}
var DarkConstructionSecondarySmall_default = DarkConstructionSecondarySmall;

// src/components/DarkConstructionPrimaryMedium.tsx
import * as React361 from "react";
function DarkConstructionPrimaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React361.createElement("img", {
    alt: "DarkConstructionPrimaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConstructionPrimaryMedium.svg",
    width
  });
}
var DarkConstructionPrimaryMedium_default = DarkConstructionPrimaryMedium;

// src/components/DarkConstructionSecondaryMedium.tsx
import * as React362 from "react";
function DarkConstructionSecondaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React362.createElement("img", {
    alt: "DarkConstructionSecondaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkConstructionSecondaryMedium.svg",
    width
  });
}
var DarkConstructionSecondaryMedium_default = DarkConstructionSecondaryMedium;

// src/components/DarkEnrollmentLoaderPrimaryLarge.tsx
import * as React363 from "react";
function DarkEnrollmentLoaderPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React363.createElement("img", {
    alt: "DarkEnrollmentLoaderPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkEnrollmentLoaderPrimaryLarge.svg",
    width
  });
}
var DarkEnrollmentLoaderPrimaryLarge_default = DarkEnrollmentLoaderPrimaryLarge;

// src/components/LightEnrollmentLoaderPrimaryLarge.tsx
import * as React364 from "react";
function LightEnrollmentLoaderPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React364.createElement("img", {
    alt: "LightEnrollmentLoaderPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightEnrollmentLoaderPrimaryLarge.svg",
    width
  });
}
var LightEnrollmentLoaderPrimaryLarge_default = LightEnrollmentLoaderPrimaryLarge;

// src/components/DarkProductTourSecondaryMedium.tsx
import * as React365 from "react";
function DarkProductTourSecondaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React365.createElement("img", {
    alt: "DarkProductTourSecondaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkProductTourSecondaryMedium.svg",
    width
  });
}
var DarkProductTourSecondaryMedium_default = DarkProductTourSecondaryMedium;

// src/components/DarkProductTourSecondarySmall.tsx
import * as React366 from "react";
function DarkProductTourSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React366.createElement("img", {
    alt: "DarkProductTourSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkProductTourSecondarySmall.svg",
    width
  });
}
var DarkProductTourSecondarySmall_default = DarkProductTourSecondarySmall;

// src/components/LightProductTourSecondarySmall.tsx
import * as React367 from "react";
function LightProductTourSecondarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React367.createElement("img", {
    alt: "LightProductTourSecondarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightProductTourSecondarySmall.svg",
    width
  });
}
var LightProductTourSecondarySmall_default = LightProductTourSecondarySmall;

// src/components/DarkProductTourSecondaryLarge.tsx
import * as React368 from "react";
function DarkProductTourSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React368.createElement("img", {
    alt: "DarkProductTourSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/DarkProductTourSecondaryLarge.svg",
    width
  });
}
var DarkProductTourSecondaryLarge_default = DarkProductTourSecondaryLarge;

// src/components/LightProductTourSecondaryLarge.tsx
import * as React369 from "react";
function LightProductTourSecondaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React369.createElement("img", {
    alt: "LightProductTourSecondaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightProductTourSecondaryLarge.svg",
    width
  });
}
var LightProductTourSecondaryLarge_default = LightProductTourSecondaryLarge;

// src/components/LightProductTourSecondaryMedium.tsx
import * as React370 from "react";
function LightProductTourSecondaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React370.createElement("img", {
    alt: "LightProductTourSecondaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightProductTourSecondaryMedium.svg",
    width
  });
}
var LightProductTourSecondaryMedium_default = LightProductTourSecondaryMedium;

// src/components/LightProductTourPrimarySmall.tsx
import * as React371 from "react";
function LightProductTourPrimarySmall({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React371.createElement("img", {
    alt: "LightProductTourPrimarySmall",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightProductTourPrimarySmall.svg",
    width
  });
}
var LightProductTourPrimarySmall_default = LightProductTourPrimarySmall;

// src/components/LightProductTourPrimaryMedium.tsx
import * as React372 from "react";
function LightProductTourPrimaryMedium({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React372.createElement("img", {
    alt: "LightProductTourPrimaryMedium",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightProductTourPrimaryMedium.svg",
    width
  });
}
var LightProductTourPrimaryMedium_default = LightProductTourPrimaryMedium;

// src/components/LightProductTourPrimaryLarge.tsx
import * as React373 from "react";
function LightProductTourPrimaryLarge({
  height = 100,
  width = 100
}) {
  return /* @__PURE__ */ React373.createElement("img", {
    alt: "LightProductTourPrimaryLarge",
    height,
    src: "https://s3.amazonaws.com/assets.playvs.com/nexus-spots/LightProductTourPrimaryLarge.svg",
    width
  });
}
var LightProductTourPrimaryLarge_default = LightProductTourPrimaryLarge;

// src/NxSpot.tsx
var FallbackComponent = /* @__PURE__ */ React374.createElement("div", null, "Component not found");
function NxSpot({
  domain = "",
  size = "large",
  height,
  width,
  variant = "primary"
}) {
  const theme = useTheme();
  const componentName = capitalize(theme.palette.type) + capitalize(domain) + capitalize(variant) + capitalize(size);
  const Component = components_exports[componentName];
  if (!Component) {
    console.warn(`Component does not exist: ${componentName}`);
    return FallbackComponent;
  }
  return /* @__PURE__ */ React374.createElement(Component, {
    height,
    width
  });
}
export {
  DarkArenaPrimaryLarge_default as DarkArenaPrimaryLarge,
  DarkArenaPrimarySmall_default as DarkArenaPrimarySmall,
  DarkArenaSecondaryLarge_default as DarkArenaSecondaryLarge,
  DarkArenaSecondarySmall_default as DarkArenaSecondarySmall,
  DarkAwardPrimaryLarge_default as DarkAwardPrimaryLarge,
  DarkAwardPrimarySmall_default as DarkAwardPrimarySmall,
  DarkAwardSecondaryLarge_default as DarkAwardSecondaryLarge,
  DarkAwardSecondarySmall_default as DarkAwardSecondarySmall,
  DarkBillingPrimaryLarge_default as DarkBillingPrimaryLarge,
  DarkBillingPrimarySmall_default as DarkBillingPrimarySmall,
  DarkBillingSecondaryLarge_default as DarkBillingSecondaryLarge,
  DarkBillingSecondarySmall_default as DarkBillingSecondarySmall,
  DarkCaptainPrimaryLarge_default as DarkCaptainPrimaryLarge,
  DarkCaptainPrimarySmall_default as DarkCaptainPrimarySmall,
  DarkCaptainSecondaryLarge_default as DarkCaptainSecondaryLarge,
  DarkCaptainSecondarySmall_default as DarkCaptainSecondarySmall,
  DarkCharacterSelectPrimaryLarge_default as DarkCharacterSelectPrimaryLarge,
  DarkCharacterSelectPrimarySmall_default as DarkCharacterSelectPrimarySmall,
  DarkCharacterSelectSecondaryLarge_default as DarkCharacterSelectSecondaryLarge,
  DarkCharacterSelectSecondarySmall_default as DarkCharacterSelectSecondarySmall,
  DarkChatPrimaryLarge_default as DarkChatPrimaryLarge,
  DarkChatPrimarySmall_default as DarkChatPrimarySmall,
  DarkChatSecondaryLarge_default as DarkChatSecondaryLarge,
  DarkChatSecondarySmall_default as DarkChatSecondarySmall,
  DarkCheckboxPrimaryLarge_default as DarkCheckboxPrimaryLarge,
  DarkCheckboxPrimarySmall_default as DarkCheckboxPrimarySmall,
  DarkCheckboxSecondaryLarge_default as DarkCheckboxSecondaryLarge,
  DarkCheckboxSecondarySmall_default as DarkCheckboxSecondarySmall,
  DarkCoachPrimaryLarge_default as DarkCoachPrimaryLarge,
  DarkCoachPrimarySmall_default as DarkCoachPrimarySmall,
  DarkCoachSecondaryLarge_default as DarkCoachSecondaryLarge,
  DarkCoachSecondarySmall_default as DarkCoachSecondarySmall,
  DarkConnectedAccountsPrimaryLarge_default as DarkConnectedAccountsPrimaryLarge,
  DarkConnectedAccountsPrimarySmall_default as DarkConnectedAccountsPrimarySmall,
  DarkConnectedAccountsSecondaryLarge_default as DarkConnectedAccountsSecondaryLarge,
  DarkConnectedAccountsSecondarySmall_default as DarkConnectedAccountsSecondarySmall,
  DarkConnectionPrimaryLarge_default as DarkConnectionPrimaryLarge,
  DarkConnectionPrimarySmall_default as DarkConnectionPrimarySmall,
  DarkConnectionSecondaryLarge_default as DarkConnectionSecondaryLarge,
  DarkConnectionSecondarySmall_default as DarkConnectionSecondarySmall,
  DarkConstructionPrimaryLarge_default as DarkConstructionPrimaryLarge,
  DarkConstructionPrimaryMedium_default as DarkConstructionPrimaryMedium,
  DarkConstructionPrimarySmall_default as DarkConstructionPrimarySmall,
  DarkConstructionSecondaryLarge_default as DarkConstructionSecondaryLarge,
  DarkConstructionSecondaryMedium_default as DarkConstructionSecondaryMedium,
  DarkConstructionSecondarySmall_default as DarkConstructionSecondarySmall,
  DarkCoursePrimaryLarge_default as DarkCoursePrimaryLarge,
  DarkCoursePrimarySmall_default as DarkCoursePrimarySmall,
  DarkCourseSecondaryLarge_default as DarkCourseSecondaryLarge,
  DarkCourseSecondarySmall_default as DarkCourseSecondarySmall,
  DarkCreateTeamPrimaryLarge_default as DarkCreateTeamPrimaryLarge,
  DarkCreateTeamPrimarySmall_default as DarkCreateTeamPrimarySmall,
  DarkCreateTeamSecondaryLarge_default as DarkCreateTeamSecondaryLarge,
  DarkCreateTeamSecondarySmall_default as DarkCreateTeamSecondarySmall,
  DarkCrownPrimaryLarge_default as DarkCrownPrimaryLarge,
  DarkCrownPrimarySmall_default as DarkCrownPrimarySmall,
  DarkCrownSecondaryLarge_default as DarkCrownSecondaryLarge,
  DarkCrownSecondarySmall_default as DarkCrownSecondarySmall,
  DarkEmailVerificationPrimaryLarge_default as DarkEmailVerificationPrimaryLarge,
  DarkEmailVerificationPrimarySmall_default as DarkEmailVerificationPrimarySmall,
  DarkEmailVerificationSecondaryLarge_default as DarkEmailVerificationSecondaryLarge,
  DarkEmailVerificationSecondarySmall_default as DarkEmailVerificationSecondarySmall,
  DarkEnrollmentLoaderPrimaryLarge_default as DarkEnrollmentLoaderPrimaryLarge,
  DarkEnrollmentPrimaryLarge_default as DarkEnrollmentPrimaryLarge,
  DarkEnrollmentPrimarySmall_default as DarkEnrollmentPrimarySmall,
  DarkEnrollmentSecondaryLarge_default as DarkEnrollmentSecondaryLarge,
  DarkEnrollmentSecondarySmall_default as DarkEnrollmentSecondarySmall,
  DarkErrorStateLarge_default as DarkErrorStateLarge,
  DarkFlagsDarkPrimaryLarge_default as DarkFlagsDarkPrimaryLarge,
  DarkFlagsDarkPrimarySmall_default as DarkFlagsDarkPrimarySmall,
  DarkFlagsDarkSecondaryLarge_default as DarkFlagsDarkSecondaryLarge,
  DarkFoamFingerPrimaryLarge_default as DarkFoamFingerPrimaryLarge,
  DarkFoamFingerPrimarySmall_default as DarkFoamFingerPrimarySmall,
  DarkFoamFingerSecondaryLarge_default as DarkFoamFingerSecondaryLarge,
  DarkFoamFingerSecondarySmall_default as DarkFoamFingerSecondarySmall,
  DarkGraduationHatPrimaryLarge_default as DarkGraduationHatPrimaryLarge,
  DarkGraduationHatPrimarySmall_default as DarkGraduationHatPrimarySmall,
  DarkGraduationHatSecondaryLarge_default as DarkGraduationHatSecondaryLarge,
  DarkGraduationHatSecondarySmall_default as DarkGraduationHatSecondarySmall,
  DarkHighAlertPrimaryLarge_default as DarkHighAlertPrimaryLarge,
  DarkHighAlertPrimarySmall_default as DarkHighAlertPrimarySmall,
  DarkHighAlertSecondaryLarge_default as DarkHighAlertSecondaryLarge,
  DarkHighAlertSecondarySmall_default as DarkHighAlertSecondarySmall,
  DarkInvitePlayersPrimaryLarge_default as DarkInvitePlayersPrimaryLarge,
  DarkInvitePlayersPrimarySmall_default as DarkInvitePlayersPrimarySmall,
  DarkInvitePlayersSecondaryLarge_default as DarkInvitePlayersSecondaryLarge,
  DarkInvitePlayersSecondarySmall_default as DarkInvitePlayersSecondarySmall,
  DarkKeyboardPrimaryLarge_default as DarkKeyboardPrimaryLarge,
  DarkKeyboardPrimarySmall_default as DarkKeyboardPrimarySmall,
  DarkKeyboardSecondaryLarge_default as DarkKeyboardSecondaryLarge,
  DarkKeyboardSecondarySmall_default as DarkKeyboardSecondarySmall,
  DarkLeaguePrimaryLarge_default as DarkLeaguePrimaryLarge,
  DarkLeaguePrimarySmall_default as DarkLeaguePrimarySmall,
  DarkLeagueSecondaryLarge_default as DarkLeagueSecondaryLarge,
  DarkLeagueSecondarySmall_default as DarkLeagueSecondarySmall,
  DarkMegaphonePrimaryLarge_default as DarkMegaphonePrimaryLarge,
  DarkMegaphonePrimarySmall_default as DarkMegaphonePrimarySmall,
  DarkMegaphoneSecondaryLarge_default as DarkMegaphoneSecondaryLarge,
  DarkMegaphoneSecondarySmall_default as DarkMegaphoneSecondarySmall,
  DarkMoneyPrimaryLarge_default as DarkMoneyPrimaryLarge,
  DarkMoneyPrimaryMedium_default as DarkMoneyPrimaryMedium,
  DarkMoneyPrimarySmall_default as DarkMoneyPrimarySmall,
  DarkMoneySecondaryLarge_default as DarkMoneySecondaryLarge,
  DarkMoneySecondaryMedium_default as DarkMoneySecondaryMedium,
  DarkMoneySecondarySmall_default as DarkMoneySecondarySmall,
  DarkMousePrimaryLarge_default as DarkMousePrimaryLarge,
  DarkMousePrimarySmall_default as DarkMousePrimarySmall,
  DarkMouseSecondaryLarge_default as DarkMouseSecondaryLarge,
  DarkMouseSecondarySmall_default as DarkMouseSecondarySmall,
  DarkNotVerifiedPrimaryLarge_default as DarkNotVerifiedPrimaryLarge,
  DarkNotVerifiedPrimarySmall_default as DarkNotVerifiedPrimarySmall,
  DarkNotVerifiedSecondaryLarge_default as DarkNotVerifiedSecondaryLarge,
  DarkNotVerifiedSecondarySmall_default as DarkNotVerifiedSecondarySmall,
  DarkNotificationPrimaryLarge_default as DarkNotificationPrimaryLarge,
  DarkNotificationPrimarySmall_default as DarkNotificationPrimarySmall,
  DarkNotificationSecondaryLarge_default as DarkNotificationSecondaryLarge,
  DarkNotificationSecondarySmall_default as DarkNotificationSecondarySmall,
  DarkPassPrimaryLarge_default as DarkPassPrimaryLarge,
  DarkPassPrimarySmall_default as DarkPassPrimarySmall,
  DarkPassSecondaryLarge_default as DarkPassSecondaryLarge,
  DarkPassSecondarySmall_default as DarkPassSecondarySmall,
  DarkPendingPrimaryLarge_default as DarkPendingPrimaryLarge,
  DarkPendingPrimarySmall_default as DarkPendingPrimarySmall,
  DarkPendingSecondaryLarge_default as DarkPendingSecondaryLarge,
  DarkPendingSecondarySmall_default as DarkPendingSecondarySmall,
  DarkProductTourSecondaryLarge_default as DarkProductTourSecondaryLarge,
  DarkProductTourSecondaryMedium_default as DarkProductTourSecondaryMedium,
  DarkProductTourSecondarySmall_default as DarkProductTourSecondarySmall,
  DarkResourcesPrimaryLarge_default as DarkResourcesPrimaryLarge,
  DarkResourcesPrimaryMedium_default as DarkResourcesPrimaryMedium,
  DarkResourcesPrimarySmall_default as DarkResourcesPrimarySmall,
  DarkResourcesSecondaryLarge_default as DarkResourcesSecondaryLarge,
  DarkResourcesSecondaryMedium_default as DarkResourcesSecondaryMedium,
  DarkResourcesSecondarySmall_default as DarkResourcesSecondarySmall,
  DarkRewardPrimaryLarge_default as DarkRewardPrimaryLarge,
  DarkRewardPrimarySmall_default as DarkRewardPrimarySmall,
  DarkRewardSecondaryLarge_default as DarkRewardSecondaryLarge,
  DarkRewardSecondarySmall_default as DarkRewardSecondarySmall,
  DarkSchedulePrimaryLarge_default as DarkSchedulePrimaryLarge,
  DarkSchedulePrimarySmall_default as DarkSchedulePrimarySmall,
  DarkScheduleSecondaryLarge_default as DarkScheduleSecondaryLarge,
  DarkScheduleSecondarySmall_default as DarkScheduleSecondarySmall,
  DarkSchoolPrimaryLarge_default as DarkSchoolPrimaryLarge,
  DarkSchoolPrimarySmall_default as DarkSchoolPrimarySmall,
  DarkSchoolSecondaryLarge_default as DarkSchoolSecondaryLarge,
  DarkSchoolSecondarySmall_default as DarkSchoolSecondarySmall,
  DarkSportsmanshipPrimaryLarge_default as DarkSportsmanshipPrimaryLarge,
  DarkSportsmanshipPrimarySmall_default as DarkSportsmanshipPrimarySmall,
  DarkSportsmanshipSecondaryLarge_default as DarkSportsmanshipSecondaryLarge,
  DarkSportsmanshipSecondarySmall_default as DarkSportsmanshipSecondarySmall,
  DarkStadiumPrimaryLarge_default as DarkStadiumPrimaryLarge,
  DarkStadiumPrimarySmall_default as DarkStadiumPrimarySmall,
  DarkStadiumSecondaryLarge_default as DarkStadiumSecondaryLarge,
  DarkStadiumSecondarySmall_default as DarkStadiumSecondarySmall,
  DarkStandingPrimaryLarge_default as DarkStandingPrimaryLarge,
  DarkStandingPrimarySmall_default as DarkStandingPrimarySmall,
  DarkStandingSecondaryLarge_default as DarkStandingSecondaryLarge,
  DarkStandingSecondarySmall_default as DarkStandingSecondarySmall,
  DarkStatsPrimaryLarge_default as DarkStatsPrimaryLarge,
  DarkStatsPrimarySmall_default as DarkStatsPrimarySmall,
  DarkStatsSecondaryLarge_default as DarkStatsSecondaryLarge,
  DarkStatsSecondarySmall_default as DarkStatsSecondarySmall,
  DarkStrategyPrimaryLarge_default as DarkStrategyPrimaryLarge,
  DarkStrategyPrimarySmall_default as DarkStrategyPrimarySmall,
  DarkStrategySecondaryLarge_default as DarkStrategySecondaryLarge,
  DarkStrategySecondarySmall_default as DarkStrategySecondarySmall,
  DarkTeamPlayerPrimaryLarge_default as DarkTeamPlayerPrimaryLarge,
  DarkTeamPlayerPrimarySmall_default as DarkTeamPlayerPrimarySmall,
  DarkTeamPlayerSecondaryLarge_default as DarkTeamPlayerSecondaryLarge,
  DarkTeamPlayerSecondarySmall_default as DarkTeamPlayerSecondarySmall,
  DarkTrophyPrimaryLarge_default as DarkTrophyPrimaryLarge,
  DarkTrophyPrimarySmall_default as DarkTrophyPrimarySmall,
  DarkTrophySecondaryLarge_default as DarkTrophySecondaryLarge,
  DarkTrophySecondarySmall_default as DarkTrophySecondarySmall,
  DarkUploadDocPrimaryLarge_default as DarkUploadDocPrimaryLarge,
  DarkUploadDocPrimarySmall_default as DarkUploadDocPrimarySmall,
  DarkUploadDocSecondaryLarge_default as DarkUploadDocSecondaryLarge,
  DarkUploadDocSecondarySmall_default as DarkUploadDocSecondarySmall,
  DarkVerificationPrimaryLarge_default as DarkVerificationPrimaryLarge,
  DarkVerificationPrimarySmall_default as DarkVerificationPrimarySmall,
  DarkVerificationSecondaryLarge_default as DarkVerificationSecondaryLarge,
  DarkVerificationSecondarySmall_default as DarkVerificationSecondarySmall,
  DarkVideoPrimaryLarge_default as DarkVideoPrimaryLarge,
  DarkVideoPrimarySmall_default as DarkVideoPrimarySmall,
  DarkVideoSecondaryLarge_default as DarkVideoSecondaryLarge,
  DarkVideoSecondarySmall_default as DarkVideoSecondarySmall,
  LightArenaPrimaryLarge_default as LightArenaPrimaryLarge,
  LightArenaPrimarySmall_default as LightArenaPrimarySmall,
  LightArenaSecondaryLarge_default as LightArenaSecondaryLarge,
  LightArenaSecondarySmall_default as LightArenaSecondarySmall,
  LightAwardPrimaryLarge_default as LightAwardPrimaryLarge,
  LightAwardPrimarySmall_default as LightAwardPrimarySmall,
  LightAwardSecondaryLarge_default as LightAwardSecondaryLarge,
  LightAwardSecondarySmall_default as LightAwardSecondarySmall,
  LightBillingPrimaryLarge_default as LightBillingPrimaryLarge,
  LightBillingPrimarySmall_default as LightBillingPrimarySmall,
  LightBillingSecondaryLarge_default as LightBillingSecondaryLarge,
  LightBillingSecondarySmall_default as LightBillingSecondarySmall,
  LightCaptainPrimaryLarge_default as LightCaptainPrimaryLarge,
  LightCaptainPrimarySmall_default as LightCaptainPrimarySmall,
  LightCaptainSecondaryLarge_default as LightCaptainSecondaryLarge,
  LightCaptainSecondarySmall_default as LightCaptainSecondarySmall,
  LightCharacterSelectPrimaryLarge_default as LightCharacterSelectPrimaryLarge,
  LightCharacterSelectPrimarySmall_default as LightCharacterSelectPrimarySmall,
  LightCharacterSelectSecondaryLarge_default as LightCharacterSelectSecondaryLarge,
  LightCharacterSelectSecondarySmall_default as LightCharacterSelectSecondarySmall,
  LightChatPrimaryLarge_default as LightChatPrimaryLarge,
  LightChatPrimarySmall_default as LightChatPrimarySmall,
  LightChatSecondaryLarge_default as LightChatSecondaryLarge,
  LightChatSecondarySmall_default as LightChatSecondarySmall,
  LightCheckboxPrimaryLarge_default as LightCheckboxPrimaryLarge,
  LightCheckboxPrimarySmall_default as LightCheckboxPrimarySmall,
  LightCheckboxSecondaryLarge_default as LightCheckboxSecondaryLarge,
  LightCheckboxSecondarySmall_default as LightCheckboxSecondarySmall,
  LightCoachPrimaryLarge_default as LightCoachPrimaryLarge,
  LightCoachPrimarySmall_default as LightCoachPrimarySmall,
  LightCoachSecondaryLarge_default as LightCoachSecondaryLarge,
  LightCoachSecondarySmall_default as LightCoachSecondarySmall,
  LightConnectedAccountsPrimaryLarge_default as LightConnectedAccountsPrimaryLarge,
  LightConnectedAccountsPrimarySmall_default as LightConnectedAccountsPrimarySmall,
  LightConnectedAccountsSecondaryLarge_default as LightConnectedAccountsSecondaryLarge,
  LightConnectedAccountsSecondarySmall_default as LightConnectedAccountsSecondarySmall,
  LightConnectionPrimaryLarge_default as LightConnectionPrimaryLarge,
  LightConnectionPrimarySmall_default as LightConnectionPrimarySmall,
  LightConnectionSecondaryLarge_default as LightConnectionSecondaryLarge,
  LightConnectionSecondarySmall_default as LightConnectionSecondarySmall,
  LightConstructionPrimaryLarge_default as LightConstructionPrimaryLarge,
  LightConstructionPrimaryMedium_default as LightConstructionPrimaryMedium,
  LightConstructionPrimarySmall_default as LightConstructionPrimarySmall,
  LightConstructionSecondaryLarge_default as LightConstructionSecondaryLarge,
  LightConstructionSecondaryMedium_default as LightConstructionSecondaryMedium,
  LightConstructionSecondarySmall_default as LightConstructionSecondarySmall,
  LightCoursePrimaryLarge_default as LightCoursePrimaryLarge,
  LightCoursePrimarySmall_default as LightCoursePrimarySmall,
  LightCourseSecondaryLarge_default as LightCourseSecondaryLarge,
  LightCourseSecondarySmall_default as LightCourseSecondarySmall,
  LightCreateTeamPrimaryLarge_default as LightCreateTeamPrimaryLarge,
  LightCreateTeamPrimarySmall_default as LightCreateTeamPrimarySmall,
  LightCreateTeamSecondaryLarge_default as LightCreateTeamSecondaryLarge,
  LightCreateTeamSecondarySmall_default as LightCreateTeamSecondarySmall,
  LightCrownPrimaryLarge_default as LightCrownPrimaryLarge,
  LightCrownPrimarySmall_default as LightCrownPrimarySmall,
  LightCrownSecondaryLarge_default as LightCrownSecondaryLarge,
  LightCrownSecondarySmall_default as LightCrownSecondarySmall,
  LightEmailVerificationPrimaryLarge_default as LightEmailVerificationPrimaryLarge,
  LightEmailVerificationPrimarySmall_default as LightEmailVerificationPrimarySmall,
  LightEmailVerificationSecondaryLarge_default as LightEmailVerificationSecondaryLarge,
  LightEmailVerificationSecondarySmall_default as LightEmailVerificationSecondarySmall,
  LightEnrollmentLoaderPrimaryLarge_default as LightEnrollmentLoaderPrimaryLarge,
  LightEnrollmentPrimaryLarge_default as LightEnrollmentPrimaryLarge,
  LightEnrollmentPrimarySmall_default as LightEnrollmentPrimarySmall,
  LightEnrollmentSecondaryLarge_default as LightEnrollmentSecondaryLarge,
  LightEnrollmentSecondarySmall_default as LightEnrollmentSecondarySmall,
  LightErrorStateLarge_default as LightErrorStateLarge,
  LightFlagsLightPrimaryLarge_default as LightFlagsLightPrimaryLarge,
  LightFlagsLightPrimarySmall_default as LightFlagsLightPrimarySmall,
  LightFlagsLightSecondaryLarge_default as LightFlagsLightSecondaryLarge,
  LightFlagsLightSecondarySmall_default as LightFlagsLightSecondarySmall,
  LightFoamFingerPrimaryLarge_default as LightFoamFingerPrimaryLarge,
  LightFoamFingerPrimarySmall_default as LightFoamFingerPrimarySmall,
  LightFoamFingerSecondaryLarge_default as LightFoamFingerSecondaryLarge,
  LightFoamFingerSecondarySmall_default as LightFoamFingerSecondarySmall,
  LightGraduationHatPrimaryLarge_default as LightGraduationHatPrimaryLarge,
  LightGraduationHatPrimarySmall_default as LightGraduationHatPrimarySmall,
  LightGraduationHatSecondaryLarge_default as LightGraduationHatSecondaryLarge,
  LightGraduationHatSecondarySmall_default as LightGraduationHatSecondarySmall,
  LightHighAlertPrimaryLarge_default as LightHighAlertPrimaryLarge,
  LightHighAlertPrimarySmall_default as LightHighAlertPrimarySmall,
  LightHighAlertSecondaryLarge_default as LightHighAlertSecondaryLarge,
  LightHighAlertSecondarySmall_default as LightHighAlertSecondarySmall,
  LightInvitePlayersPrimaryLarge_default as LightInvitePlayersPrimaryLarge,
  LightInvitePlayersPrimarySmall_default as LightInvitePlayersPrimarySmall,
  LightInvitePlayersSecondaryLarge_default as LightInvitePlayersSecondaryLarge,
  LightInvitePlayersSecondarySmall_default as LightInvitePlayersSecondarySmall,
  LightKeyboardPrimaryLarge_default as LightKeyboardPrimaryLarge,
  LightKeyboardPrimarySmall_default as LightKeyboardPrimarySmall,
  LightKeyboardSecondaryLarge_default as LightKeyboardSecondaryLarge,
  LightKeyboardSecondarySmall_default as LightKeyboardSecondarySmall,
  LightLeaguePrimaryLarge_default as LightLeaguePrimaryLarge,
  LightLeaguePrimarySmall_default as LightLeaguePrimarySmall,
  LightLeagueSecondaryLarge_default as LightLeagueSecondaryLarge,
  LightLeagueSecondarySmall_default as LightLeagueSecondarySmall,
  LightMegaphonePrimaryLarge_default as LightMegaphonePrimaryLarge,
  LightMegaphonePrimarySmall_default as LightMegaphonePrimarySmall,
  LightMegaphoneSecondaryLarge_default as LightMegaphoneSecondaryLarge,
  LightMegaphoneSecondarySmall_default as LightMegaphoneSecondarySmall,
  LightMoneyPrimaryLarge_default as LightMoneyPrimaryLarge,
  LightMoneyPrimarySmall_default as LightMoneyPrimarySmall,
  LightMoneySecondaryLarge_default as LightMoneySecondaryLarge,
  LightMoneySecondarySmall_default as LightMoneySecondarySmall,
  LightMousePrimaryLarge_default as LightMousePrimaryLarge,
  LightMousePrimarySmall_default as LightMousePrimarySmall,
  LightMouseSecondaryLarge_default as LightMouseSecondaryLarge,
  LightMouseSecondarySmall_default as LightMouseSecondarySmall,
  LightNotVerifiedPrimaryLarge_default as LightNotVerifiedPrimaryLarge,
  LightNotVerifiedPrimarySmall_default as LightNotVerifiedPrimarySmall,
  LightNotVerifiedSecondaryLarge_default as LightNotVerifiedSecondaryLarge,
  LightNotVerifiedSecondarySmall_default as LightNotVerifiedSecondarySmall,
  LightNotificationPrimaryLarge_default as LightNotificationPrimaryLarge,
  LightNotificationPrimarySmall_default as LightNotificationPrimarySmall,
  LightNotificationSecondarySmall_default as LightNotificationSecondarySmall,
  LightPassPrimaryLarge_default as LightPassPrimaryLarge,
  LightPassPrimarySmall_default as LightPassPrimarySmall,
  LightPassSecondaryLarge_default as LightPassSecondaryLarge,
  LightPassSecondarySmall_default as LightPassSecondarySmall,
  LightPendingPrimaryLarge_default as LightPendingPrimaryLarge,
  LightPendingPrimarySmall_default as LightPendingPrimarySmall,
  LightPendingSecondaryLarge_default as LightPendingSecondaryLarge,
  LightPendingSecondarySmall_default as LightPendingSecondarySmall,
  LightProductTourPrimaryLarge_default as LightProductTourPrimaryLarge,
  LightProductTourPrimaryMedium_default as LightProductTourPrimaryMedium,
  LightProductTourPrimarySmall_default as LightProductTourPrimarySmall,
  LightProductTourSecondaryLarge_default as LightProductTourSecondaryLarge,
  LightProductTourSecondaryMedium_default as LightProductTourSecondaryMedium,
  LightProductTourSecondarySmall_default as LightProductTourSecondarySmall,
  LightResourcesPrimaryLarge_default as LightResourcesPrimaryLarge,
  LightResourcesPrimaryMedium_default as LightResourcesPrimaryMedium,
  LightResourcesPrimarySmall_default as LightResourcesPrimarySmall,
  LightResourcesSecondaryLarge_default as LightResourcesSecondaryLarge,
  LightResourcesSecondaryMedium_default as LightResourcesSecondaryMedium,
  LightResourcesSecondarySmall_default as LightResourcesSecondarySmall,
  LightRewardPrimaryLarge_default as LightRewardPrimaryLarge,
  LightRewardPrimarySmall_default as LightRewardPrimarySmall,
  LightRewardSecondaryLarge_default as LightRewardSecondaryLarge,
  LightRewardSecondarySmall_default as LightRewardSecondarySmall,
  LightSchedulePrimaryLarge_default as LightSchedulePrimaryLarge,
  LightSchedulePrimarySmall_default as LightSchedulePrimarySmall,
  LightScheduleSecondaryLarge_default as LightScheduleSecondaryLarge,
  LightScheduleSecondarySmall_default as LightScheduleSecondarySmall,
  LightSchoolPrimaryLarge_default as LightSchoolPrimaryLarge,
  LightSchoolPrimarySmall_default as LightSchoolPrimarySmall,
  LightSchoolSecondaryLarge_default as LightSchoolSecondaryLarge,
  LightSchoolSecondarySmall_default as LightSchoolSecondarySmall,
  LightSportsmanshipPrimaryLarge_default as LightSportsmanshipPrimaryLarge,
  LightSportsmanshipPrimarySmall_default as LightSportsmanshipPrimarySmall,
  LightSportsmanshipSecondaryLarge_default as LightSportsmanshipSecondaryLarge,
  LightSportsmanshipSecondarySmall_default as LightSportsmanshipSecondarySmall,
  LightStadiumPrimaryLarge_default as LightStadiumPrimaryLarge,
  LightStadiumPrimarySmall_default as LightStadiumPrimarySmall,
  LightStadiumSecondaryLarge_default as LightStadiumSecondaryLarge,
  LightStadiumSecondarySmall_default as LightStadiumSecondarySmall,
  LightStandingPrimaryLarge_default as LightStandingPrimaryLarge,
  LightStandingPrimarySmall_default as LightStandingPrimarySmall,
  LightStandingSecondaryLarge_default as LightStandingSecondaryLarge,
  LightStandingSecondarySmall_default as LightStandingSecondarySmall,
  LightStatsPrimaryLarge_default as LightStatsPrimaryLarge,
  LightStatsPrimarySmall_default as LightStatsPrimarySmall,
  LightStatsSecondaryLarge_default as LightStatsSecondaryLarge,
  LightStatsSecondarySmall_default as LightStatsSecondarySmall,
  LightStrategyPrimaryLarge_default as LightStrategyPrimaryLarge,
  LightStrategyPrimarySmall_default as LightStrategyPrimarySmall,
  LightStrategySecondaryLarge_default as LightStrategySecondaryLarge,
  LightStrategySecondarySmall_default as LightStrategySecondarySmall,
  LightTeamPlayerPrimaryLarge_default as LightTeamPlayerPrimaryLarge,
  LightTeamPlayerPrimarySmall_default as LightTeamPlayerPrimarySmall,
  LightTeamPlayerSecondaryLarge_default as LightTeamPlayerSecondaryLarge,
  LightTeamPlayerSecondarySmall_default as LightTeamPlayerSecondarySmall,
  LightTrophyPrimaryLarge_default as LightTrophyPrimaryLarge,
  LightTrophyPrimarySmall_default as LightTrophyPrimarySmall,
  LightTrophySecondaryLarge_default as LightTrophySecondaryLarge,
  LightTrophySecondarySmall_default as LightTrophySecondarySmall,
  LightUploadDocPrimaryLarge_default as LightUploadDocPrimaryLarge,
  LightUploadDocPrimarySmall_default as LightUploadDocPrimarySmall,
  LightUploadDocSecondaryLarge_default as LightUploadDocSecondaryLarge,
  LightUploadDocSecondarySmall_default as LightUploadDocSecondarySmall,
  LightVerificationPrimaryLarge_default as LightVerificationPrimaryLarge,
  LightVerificationPrimarySmall_default as LightVerificationPrimarySmall,
  LightVerificationSecondaryLarge_default as LightVerificationSecondaryLarge,
  LightVerificationSecondarySmall_default as LightVerificationSecondarySmall,
  LightVideoPrimaryLarge_default as LightVideoPrimaryLarge,
  LightVideoPrimarySmall_default as LightVideoPrimarySmall,
  LightVideoSecondaryLarge_default as LightVideoSecondaryLarge,
  LightVideoSecondarySmall_default as LightVideoSecondarySmall,
  NxSpot
};
//# sourceMappingURL=index.js.map